import { en as RetailerSetup } from './retailerSetup';

export default {
    CatalogWorkspace: {
        title: 'Catalog import & sync',
        intro: 'Connect a catalog feed, upload a file, or manage your store integrations.',
        navigation: 'Catalog import and settings',
        sources: 'Feeds and URLs',
        upload: 'Upload CSV',
        stores: 'Store integrations',
        scraper: 'Custom scraper',
        categories: 'Category mapping',
        sourceHelp: 'Add a catalog URL, review a sample, and confirm the field mapping before the first sync.',
        uploadHelp: 'Upload a CSV file to seed your catalog or apply a one-time update.',
        storesHelp: 'Manage connected stores and their secure integrations.',
        categoriesHelp: 'Review and confirm how feed categories map to DigiWarranty categories.',
        scraperTitle: 'Catalog source managed by a custom scraper',
        scraperHelp: 'A scraper is configured for a specific store. Do not enter a regular storefront URL as a CSV/XML/JSON feed. Existing scraper sources appear with your feeds; adding one requires administrator configuration.',
    },
    RetailerSetup,
    "PluginConnect": {
        "loading": "Loading secure connection...",
        "unavailable": "Connection unavailable",
        "incomplete": "The connection link is incomplete.",
        "expired": "This connection session is unavailable or has expired.",
        "failed": "The store could not be connected. Please try again.",
        "title": "Connect {{platform}} store",
        "intro": "Review and approve the organization that will own this integration.",
        "store": "Store",
        "website": "Website",
        "catalog": "Catalog",
        "catalogValue": "{{products}} products, {{discounts}} discounts",
        "noOrganization": "No eligible organization found",
        "noOrganizationHelp": "If you just registered, verify your email and sign in to continue this connection. Your account must be an organization administrator.",
        "organization": "Organization",
        "venue": "Online venue name",
        "venueName": "New online venue name",
        "createVenue": "Create a new online venue",
        "permissions": "DigiWarranty will be allowed to:",
        "permissionCatalog": "Sync products, prices, stock and active discounts",
        "permissionReceipts": "Send receipts only when the shopper opts in",
        "permissionVenue": "Use an existing online venue or create one for this {{platform}} store",
        "consent": "I authorize this {{platform}} store to connect to {{organization}}.",
        "security": "Secure one-time authorization",
        "connecting": "Connecting...",
        "connect": "Connect store"
    },
    "Add Condition": "Add Condition",
    "Add Incentive": "Add Incentive",
    "Add Strategy": "Add Strategy",
    "Add Target": "Add Target",
    "AdminNotificationLogs": {
        "title": "Notification Logs",
        "tabs": {
            "logs": "Sent Notifications",
            "devices": "Users & Devices"
        },
        "columns": {
            "sent": "Sent",
            "type": "Type",
            "title": "Notification",
            "user": "User",
            "devices": "Delivery",
            "devicesTotal": "Devices",
            "reachable": "Reachable",
            "lastSeen": "Last seen",
            "device": "Device",
            "status": "Status",
            "error": "Error",
            "registered": "Registered"
        },
        "stats": {
            "total": "Notifications",
            "sent": "Push sent",
            "opened": "Opened",
            "failed": "Failed"
        },
        "sent": "Sent",
        "opened": "Opened",
        "failed": "Failed",
        "reachable": "Reachable",
        "unreachable": "Unreachable",
        "inactive": "Inactive",
        "revoked": "Revoked",
        "noDevice": "No device",
        "noDeliveries": "No push was attempted for this notification.",
        "searchLogs": "Search title, body or user email…",
        "searchUsers": "Search name or email…",
        "failedOnly": "Failed only",
        "unreachableOnly": "Unreachable only",
        "refresh": "Refresh",
        "empty": "Nothing to show."
    },
    "AdminNav": {
        "organizationApprovals": "Registration requests",
        "categoryMapping": "Category Mapping",
        "dashboard": "Dashboard",
        "organizations": "Organizations",
        "promotionTypes": "Promotion Types",
        "scannedBills": "Scanned Bills",
        "users": "Users",
        "customers": "Customers",
        "venues": "Venues",
        "cities": "Cities",
        "scraperStaging": "Scraper Staging",
        "catalogOperations": "Catalogue Operations",
        "alerts": "Alerts",
        "notifications": "Notifications",
        "notificationLogs": "Notification Logs",
        "giveaways": "Giveaways",
        "globalPointsSettings": "Global Points Settings",
        "freshness": "Data Freshness",
        "transactions": "Transactions",
        "revenue": "Revenue",
        "billingProfiles": "Billing Profiles",
        "planOffers": "Plans and Private Offers",
        "bills": "Bills",
        "invoices": "Invoices",
        "contracts": "Contracts",
        "reconciliation": "Reconciliation",
        "integrations": "Integrations",
        "integrationLogs": "Integration Logs",
        "integrationSync": "Integration Sync",
        "integrationQuotas": "Integration Quotas"
    },
    "AdminNavGroups": {
        "cmsRules": "CMS & Rules",
        "identity": "Identity & Tenants",
        "operations": "Operations",
        "overview": "Overview"
    },
    "AuthorizedServices": {
        "addNewService": "Add New Service",
        "addService": "Add Authorized Service",
        "address": "Address",
        "cancel": "Cancel",
        "create": "Create",
        "createService": "Create Authorized Service",
        "name": "Name",
        "noServices": "No authorized services available.",
        "overview": "Authorized Service Centers Overview",
        "phone": "Phone",
        "serviceAddress": "Service Address",
        "serviceName": "Service Name",
        "servicePhone": "Service Phone",
        "title": "Title"
    },
    "Back": "Back",
    "BillApprovalDetail": {
        "alreadyApproved": "This bill has been approved",
        "alreadyRejected": "This bill has been rejected",
        "approvalWarning": "Approving this bill will create an official transaction record and activate warranties for the items.",
        "approve": "Approve Bill",
        "approveSuccess": "Bill approved successfully.",
        "back": "Back to approvals",
        "error": "Failed to load bill.",
        "fields": {
            "address": "Address",
            "billDate": "Bill Date",
            "billNumber": "Bill Number",
            "email": "Email",
            "name": "Name",
            "paymentMethod": "Payment Method",
            "phone": "Phone",
            "total": "Total Amount",
            "venueName": "Venue Name"
        },
        "items": {
            "price": "Price",
            "product": "Product",
            "quantity": "Qty",
            "total": "Total"
        },
        "loading": "Loading bill...",
        "noItems": "No items on this bill.",
        "notFound": "Bill not found.",
        "notesPlaceholder": "Add any notes about this review...",
        "processing": "Processing...",
        "reject": "Reject Bill",
        "rejectModal": {
            "cancel": "Cancel",
            "confirm": "Confirm Rejection",
            "description": "Please select a reason for rejecting this bill.",
            "reasons": {
                "duplicate": "Duplicate submission",
                "invalidReceipt": "Invalid or illegible receipt",
                "itemsMismatch": "Items do not match receipt",
                "other": "Other reason",
                "unreadable": "Cannot read bill details",
                "wrongStore": "Receipt is not from our store"
            },
            "selectReason": "Select a reason...",
            "title": "Reject Bill"
        },
        "rejectSuccess": "Bill rejected successfully.",
        "rejectionReason": "Rejection Reason",
        "reviewNotes": "Review Notes",
        "reviewedAt": "Reviewed at",
        "sections": {
            "billDetails": "Bill Details",
            "customer": "Customer Information",
            "images": "Bill Images",
            "items": "Items",
            "reviewNotes": "Review Notes",
            "venue": "Venue"
        },
        "title": "Bill Review",
        "virtualProduct": "Virtual",
        "virtualVenue": "Virtual Venue"
    },
    "BillApprovals": {
        "actions": {
            "view": "View"
        },
        "columns": {
            "actions": "Actions",
            "billNumber": "Bill #",
            "customer": "Customer",
            "date": "Date",
            "items": "Items",
            "status": "Status",
            "total": "Total",
            "venue": "Venue"
        },
        "empty": {
            "description": "All bills have been reviewed. New bills will appear here when customers submit them.",
            "title": "No pending approvals"
        },
        "error": "Failed to load bills.",
        "filters": {
            "all": "All",
            "status": "Status"
        },
        "loading": "Loading bills...",
        "stats": {
            "approved": "Approved",
            "pending": "Pending",
            "rejected": "Rejected",
            "thisWeek": "This Week"
        },
        "status": {
            "approved": "Approved",
            "pending": "Pending",
            "rejected": "Rejected"
        },
        "subtitle": "Review and approve bills submitted by customers for your stores.",
        "title": "Bill Approvals"
    },
    "Calculation": "Calculation",
    "Campaign Details": "Campaign Details",
    "Campaign Wizard": "Campaign Wizard",
    "Campaign updated successfully!": "Campaign updated successfully!",
    "Campaigns": {
        "CampaignCreate": {
            "budget": "Budget",
            "cancel": "Cancel",
            "createCampaign": "Create Campaign",
            "creating": "Creating",
            "description": "Description",
            "endDate": "End Date",
            "error": "Error",
            "goalDescription": "Goal Description",
            "loading": "Creating campaign...",
            "name": "Campaign Name",
            "startDate": "Start Date",
            "title": "Create New Campaign"
        },
        "CampaignEdit": {
            "Tutorial": {
                "addPromotionInstruction": "Use the 'Add Promotion' button to create a new promotion.",
                "campaignSettingsMessage": "In this section, you can configure the basic settings of your campaign.",
                "campaignSettingsTitle": "Campaign Settings Overview",
                "conditionsInstruction1": "You can add multiple conditions for a promotion.",
                "conditionsInstruction2": "Ensure conditions are met before the promotion goes live.",
                "conditionsMessage": "Conditions are rules that determine when a promotion is active.",
                "conditionsTitle": "Conditions",
                "incentivesInstruction1": "Consider what incentives will be most appealing to your audience.",
                "incentivesInstruction2": "You can offer multiple types of incentives for each promotion.",
                "incentivesMessage": "Incentives are benefits you offer to encourage customer participation.",
                "incentivesTitle": "Incentives",
                "promotionEditInstruction": "Click on a promotion to edit its details.",
                "promotionsListMessage": "This section displays all the promotions associated with your campaign.",
                "promotionsListTitle": "Promotions List",
                "schedulesInstruction1": "Set start and end dates for your promotions.",
                "schedulesInstruction2": "Adjust your schedules based on campaign performance.",
                "schedulesMessage": "Schedules determine the timing of your promotions.",
                "schedulesTitle": "Schedules",
                "strategiesInstruction1": "You can add multiple strategies to a promotion.",
                "strategiesInstruction2": "Choose the best strategies based on your campaign goals.",
                "strategiesMessage": "Strategies define how a promotion will be executed.",
                "strategiesTitle": "Strategies",
                "targetsInstruction1": "Define your target audience carefully.",
                "targetsInstruction2": "You can add multiple targets for each promotion.",
                "targetsMessage": "Targets are the audience segments you want to reach with your promotion.",
                "targetsTitle": "Targets",
                "tutorialTitle": "Campaign Edit Tutorial",
                "welcomeMessage": "Welcome to the Campaign Edit tutorial! Here you will learn how to effectively manage your campaigns."
            },
            "analysisTab": "Analyse Campaign",
            "backToCampaigns": "Back To Campaigns",
            "breakdown": "Campaign Breakdown",
            "budget": "Budget",
            "calculate": "Calculate",
            "calculationSuccess": "Calculation Success",
            "calculations": "Analysis & Suggestions",
            "clickCalculatePlaceholder": "Click Calculate Placeholder",
            "description": "Description",
            "editCampaignTitle": "Edit Campaign",
            "editTab": "Edit Campaign",
            "endDate": "End Date",
            "failedCalculation": "Failed to calculate the campaign data",
            "failedLoad": "Failed Load",
            "failedUpdate": "Failed to update the campaign",
            "generalDetails": "General Details",
            "goalDescription": "Goal Description",
            "initialReach": "Initial Reach",
            "initialReachPromotion": "Initial Reach: {value}",
            "managePromotions": "Manage Your Promotions",
            "name": "Campaign Name",
            "noSuggestions": "No suggestions available.",
            "noSuggestionsAvailable": "No suggestions available.",
            "placeholderBudget": "Enter campaign budget",
            "placeholderDescription": "Enter campaign description",
            "placeholderEndDate": "Select end date",
            "placeholderGoalDescription": "Enter campaign goal description",
            "placeholderName": "Enter campaign name",
            "placeholderStartDate": "Select start date",
            "price": "Price",
            "priceStrategy": "Strategy {index} (Type: {type}) Price: ${price}",
            "prices": "Prices",
            "pricesLabel": "Prices",
            "promotion": "Promotion",
            "promotionLabel": "Promotion {index}",
            "promotionsTab": "Edit Promotions",
            "reach": "Reach",
            "reaches": "Reaches",
            "revenue": "Revenue",
            "startDate": "Start Date",
            "strategy": "Strategy",
            "strategyReach": "Strategy {index} (Type: {type}) Reach: {value}",
            "successUpdate": "Campaign updated successfully",
            "suggestions": "Suggestions",
            "suggestionsForPromotion": "Promotion {index} Suggestions:",
            "target": "Target {index} Reach",
            "timelineAndBudget": "Timeline And Budget",
            "totalBudget": "Total Budget",
            "type": "Type",
            "updateCampaign": "Update Campaign",
            "welcomeMessage": "Welcome to the Campaign Edit Page!"
        },
        "PromotionEdit": {
            "addCondition": "Add Condition",
            "addIncentive": "Add Incentive",
            "addStrategy": "Add Strategy",
            "addTarget": "Add Target",
            "basicInformation": "Basic Information",
            "conditions": "Conditions({{count}})",
            "editOverlay": "Edit Overlay",
            "editPromotion": "Edit Promotion: {{promotionName}}",
            "incentives": "Incentives({{count}})",
            "promotionName": "Promotion",
            "promotionOverlay": "Promotion Overlay",
            "strategies": "Strategies({{count}})",
            "targets": "Targets({{count}})"
        },
        "PromotionList": {
            "addPromotion": "Add Promotion",
            "promotion": "Promotion {{index}}",
            "promotionsList": "Promotions List"
        },
        "PromotionWizard": {
            "conditions": "Conditions",
            "finish": "Finish",
            "incentives": "Incentives",
            "next": "Next",
            "previous": "Previous",
            "settings": "Settings",
            "stepIndicator": "Step Indicator",
            "strategies": "Strategies",
            "targets": "Targets",
            "title": "Title"
        },
        "Tutorial": {
            "createCampaignMessage": "Here you can create a new campaign for your business needs.",
            "createCampaignTitle": "Create New Campaign",
            "manageCampaignsMessage": "In this section, you can view, edit, and delete your existing campaigns. Use the search bar to quickly find a specific campaign.",
            "manageCampaignsTitle": "Manage Your Campaigns",
            "tutorialMessage": "This tutorial will guide you through the process of managing campaigns effectively.",
            "tutorialTitle": "Campaigns Tutorial",
            "welcomeMessage": "Welcome to the Campaigns Management!"
        },
        "actions": "Actions",
        "addNew": "Add New Campaign",
        "budget": "Budget",
        "calculating": "Calculating",
        "delete": "Delete",
        "deleteConfirm": "Delete Confirm",
        "deleteError": "Delete Error",
        "deleteSuccess": "Delete Success",
        "deleteTitle": "Delete Title",
        "description": "Description",
        "edit": "Edit",
        "emptyDescription": "Empty Description",
        "emptyTitle": "Empty Title",
        "endDate": "End Date",
        "goalDescription": "Goal Description",
        "loadError": "Load Error",
        "name": "Name",
        "noCampaigns": "No campaigns found.",
        "saving": "Saving",
        "search": "Search campaigns...",
        "startDate": "Start Date",
        "title": "Campaigns"
    },
    "Common": {
        "search": "Search",
        "actions": "Actions",
        "active": "Active",
        "address": "Address",
        "all": "All",
        "back": "Back",
        "cancel": "Cancel",
        "change": "Change",
        "city": "City",
        "country": "Country",
        "date": "Date",
        "delete": "Delete",
        "edit": "Edit",
        "email": "Email",
        "extracted": "Extracted",
        "items": "Items",
        "key": "Key",
        "manufacturer": "Manufacturer",
        "name": "Name",
        "no": "No",
        "open": "Open",
        "phone": "Phone",
        "product": "Product",
        "real": "Real",
        "refresh": "Refresh",
        "required": "Required",
        "retailer": "Retailer",
        "rows": "Rows",
        "save": "Save",
        "saveChanges": "Save Changes",
        "select": "Select",
        "selected": "Selected",
        "surname": "Surname",
        "total": "Total",
        "user": "User",
        "venue": "Venue",
        "virtual": "Virtual",
        "yes": "Yes",
        "hide": "Hide",
        "inactive": "Inactive",
        "loading": "Loading",
        "notAvailable": "Not Available",
        "show": "Show"
    },
    "Condition Name": "Condition Name",
    "Conditions": "Conditions",
    "Criteria": "Criteria",
    "CrossSellEarnings": {
        "chart": {
            "commission": "Commission Earned",
            "purchase": "Purchase Amount",
            "title": "Cross-sell Performance",
            "transactions": "Transactions"
        },
        "errors": {
            "generic": "Unable to load cross-sell earnings. Please try again."
        },
        "table": {
            "columns": {
                "averageCommission": "Avg. Commission %",
                "commission": "Commission Earned",
                "fees": "Transaction Fees",
                "period": "Period",
                "purchase": "Purchase Amount",
                "sellers": "Sellers",
                "transactions": "Transactions"
            },
            "empty": "No cross-sell data for this period.",
            "title": "Period Breakdown"
        },
        "title": "Cross Selling Earnings",
        "totals": {
            "averageCommission": "Average Commission %",
            "distinctSellers": "Distinct Sellers",
            "totalCommission": "Commission Earned",
            "totalFee": "Transaction Fees",
            "totalPurchase": "Cross-sell Purchase Volume",
            "totalTransactions": "Cross-sell Transactions"
        },
        "view": {
            "daily": "Daily",
            "monthly": "Monthly"
        }
    },
    "Dashboard": {
        "Tutorial": {
            "explanation_message": "This dashboard displays your organization's statistics from the day of registration. You can customize the view according to your preferences.",
            "explanation_title": "Overview",
            "title": "Dashboard Tutorial"
        },
        "average_revenue_per_user": "Average Revenue per User",
        "average_selling_transaction_value": "Average Selling Transaction Value",
        "activeDiscounts": "Active discounts",
        "availableProducts": "Available products",
        "belonging_users_count": "Belonging Users Count",
        "campaigns_count": "Campaigns Count",
        "catalogProducts": "Catalog products",
        "catalogClicks": "Catalog product clicks · 30 days",
        "catalogDetailViews": "Catalog detail opens · 30 days",
        "catalogImpressions": "Catalog impressions · 30 days",
        "catalogSync": "Catalog sync",
        "discountClicks": "Retailer offer clicks · 30 days",
        "discountDetailViews": "Discount detail opens · 30 days",
        "discountImpressions": "Discount impressions · 30 days",
        "error": "Error loading dashboard data",
        "loading": "Loading...",
        "manufacturer_count": "Manufacturer Count",
        "manageCatalog": "Manage catalog",
        "noSyncYet": "No catalog sync has run yet.",
        "revenue_value": "Revenue Value",
        "selling_transactions_count": "Selling Transactions Count",
        "setup_add_address_cta": "Add address",
        "setup_add_address_desc": "Add your business location and country details.",
        "setup_add_address_title": "Complete company address",
        "setup_add_billing_email_cta": "Add billing email",
        "setup_add_billing_email_desc": "Ensure invoices and billing updates reach the right inbox.",
        "setup_add_billing_email_title": "Add billing email",
        "setup_add_contact_cta": "Add contacts",
        "setup_add_contact_desc": "Provide an email and phone number for support and billing.",
        "setup_add_contact_title": "Add contact details",
        "setup_add_description_cta": "Add description",
        "setup_add_description_desc": "Tell partners and users what your organization does.",
        "setup_add_description_title": "Add a company description",
        "setup_add_venue_cta": "Create venue",
        "setup_add_venue_desc": "Add a venue so you can start importing products.",
        "setup_add_venue_title": "Create your first venue",
        "setup_add_website_cta": "Add website",
        "setup_add_website_desc": "Share your official website with customers and partners.",
        "setup_add_website_title": "Add company website",
        "setup_complete_description": "Your company details are set. Dashboard activity will appear here as you start using DigiWarranty.",
        "setup_complete_title": "You’re all set",
        "setup_loyalty_points_cta": "Configure points",
        "setup_loyalty_points_desc": "Define how many points customers earn per purchase.",
        "setup_loyalty_points_title": "Set loyalty points",
        "setup_set_localization_cta": "Set localization",
        "setup_set_localization_desc": "Choose your currency, timezone, and language for reports.",
        "setup_set_localization_title": "Set localization preferences",
        "setup_intro": "Add the key details your team needs to get started. You can finish the rest later.",
        "setup_next": "Recommended next step",
        "setup_other_steps": "View remaining setup steps ({{count}})",
        "setup_remaining": "Setup steps remaining: {{count}}",
        "setup_title": "Get your company ready",
        "retailerOverview": "Store overview",
        "retailerOverviewDescription": "Your catalog, active offers and customer engagement at a glance.",
        "syncCreated": "{{count}} added",
        "syncErrors": "{{count}} issues",
        "syncStatus_failed": "Last sync failed",
        "syncStatus_ok": "Last sync completed successfully",
        "syncStatus_partial": "Last sync completed with some issues",
        "syncStatus_queued": "Sync queued",
        "syncStatus_running": "Sync in progress",
        "syncStatus_skipped": "Last sync was skipped",
        "syncStatus_timeout": "Last sync timed out",
        "syncStatus_unknown": "Sync status unavailable",
        "syncUpdated": "{{count}} updated",
        "unlimited": "Unlimited",
        "viewAnalytics": "View analytics",
        "setup_upload_logo_cta": "Add logo",
        "setup_upload_logo_desc": "Add a logo so your brand appears across the dashboard and documents.",
        "setup_upload_logo_title": "Upload your company logo",
        "sold_items_count": "Sold Items Count",
        "title": "Dashboard",
        "total_transaction_volume": "Total Transaction Volume",
        "users_count": "Users Count",
        "venues_count": "Venues Count"
    },
    "DistributorBestOffers": {
        "empty": "No manufacturer incentives are live right now.",
        "error": "Unable to load incentives.",
        "subtitle": "See which manufacturers are subsidizing your outbound pipeline this week.",
        "title": "Manufacturer incentives",
        "validUntil": "Valid until {{end}}"
    },
    "DistributorDashboard": {
        "error": "Unable to load distributor dashboard.",
        "insights": {
            "actionItems": "Action Items",
            "noActions": "No pending actions",
            "topManufacturers": "Top Manufacturers",
            "topRegions": "Top Regions",
            "topRetailers": "Top Retailers"
        },
        "inventory": {
            "copy": "Aggregated stock across every distributor hub.",
            "inboundQuantity": "Inbound quantity",
            "outboundQuantity": "Outbound quantity",
            "title": "Warehouse capacity"
        },
        "loading": "Loading distributor metrics...",
        "metrics": {
            "activeManufacturers": "Active Manufacturers",
            "activeRetailers": "Active Retailers",
            "activeVenues": "Active Logistics Hubs",
            "averageFulfillmentTime": "Avg. Fulfillment Time",
            "campaignsSupported": "Campaigns Supported",
            "inboundQuantity": "Inbound Quantity",
            "inboundValue": "Inbound Value",
            "integrationAlerts": "Integration Alerts",
            "inventoryOnHand": "Inventory On Hand",
            "openSupportCases": "Open Support Cases",
            "orderFillRate": "Order Fill Rate",
            "outboundQuantity": "Outbound Quantity",
            "outboundValue": "Outbound Value",
            "returnsRate": "Returns Rate",
            "skuPortfolio": "SKU Portfolio"
        },
        "sections": {
            "flow": {
                "copy": "Track the movement of units across inbound and outbound lanes, along with fulfillment pace.",
                "title": "Flow performance"
            },
            "health": {
                "copy": "Quality signals such as returns, support workload, integration alerts, and joint campaigns.",
                "title": "Reliability & engagement"
            },
            "network": {
                "copy": "How many partners, venues, and SKUs you actively touch today.",
                "title": "Channel coverage"
            }
        },
        "title": "Distributor Dashboard"
    },
    "DistributorDiscounts": {
        "empty": "No distributor discounts recorded yet.",
        "error": "Unable to load distributor discounts.",
        "filters": {
            "all": "All"
        },
        "importButton": "Import discounts CSV",
        "importSoon": "CSV import will be available soon.",
        "status": {
            "active": "Active",
            "expired": "Expired",
            "upcoming": "Upcoming"
        },
        "subtitle": "Manage the promotions you extend to retailers across venues.",
        "summary": {
            "active": "Active",
            "expired": "Expired",
            "upcoming": "Upcoming"
        },
        "table": {
            "discount": "Discount",
            "end": "Valid until",
            "global": "All venues",
            "product": "Product",
            "status": "Status",
            "venue": "Venue"
        },
        "title": "Distributor discounts"
    },
    "DistributorImportExport": {
        "actions": {
            "startExport": "Queue export",
            "startImport": "Queue import",
            "submitting": "Submitting..."
        },
        "error": "Unable to load import/export jobs.",
        "exports": {
            "requestSubtitle": "Generate downstream packages for your brands and retailers.",
            "requestTitle": "Schedule export"
        },
        "form": {
            "fileName": "File name (optional)",
            "sourceName": "Source name",
            "sourceUrl": "Source URL",
            "type": "Type"
        },
        "history": {
            "exports": "Export history",
            "imports": "Import history"
        },
        "imports": {
            "requestSubtitle": "Pull SKU, warranty, or retailer updates via CSV/JSON.",
            "requestTitle": "Start new import"
        },
        "loading": "Loading jobs...",
        "status": {
            "completed": "Completed",
            "failed": "Failed",
            "pending": "Pending",
            "processing": "Processing"
        },
        "subtitle": "Sync SKU catalogs, warranty templates, and retailer lists with partners.",
        "table": {
            "date": "Date",
            "download": "Download",
            "file": "File",
            "progress": "Progress",
            "source": "Source",
            "status": "Status",
            "type": "Type"
        },
        "tabs": {
            "exports": "Exports",
            "imports": "Imports"
        },
        "title": "Imports & Exports",
        "toast": {
            "error": "Unable to complete the request",
            "exportCreated": "Export requested",
            "importCreated": "Import queued"
        },
        "types": {
            "retailer": "Retailer mappings",
            "sku": "SKU catalog",
            "warranty": "Warranty templates"
        }
    },
    "DistributorIntegrations": {
        "actions": {
            "add": "Add connector",
            "cancel": "Cancel",
            "confirmDelete": "Remove this connector?",
            "save": "Save",
            "saving": "Saving...",
            "testWebhook": "Test webhook"
        },
        "addTitle": "Add connector",
        "detail": {
            "apiKey": "API key",
            "apiSecret": "API secret (copy now)",
            "endpoint": "API endpoint",
            "sync": "Sync interval",
            "type": "Connector type",
            "webhookSecret": "Webhook secret",
            "webhookUrl": "Webhook URL"
        },
        "editTitle": "Edit connector",
        "empty": "Select a connector to see details.",
        "error": "Unable to load integrations.",
        "form": {
            "custom": "Custom",
            "email": "Contact email",
            "endpoint": "Endpoint URL",
            "isActive": "Integration active",
            "name": "Name",
            "sync": "Sync interval",
            "syncDaily": "Daily",
            "syncHourly": "Hourly",
            "syncRealtime": "Real time",
            "type": "Type",
            "webhook": "Webhook URL"
        },
        "loading": "Loading integrations...",
        "stats": {
            "active": "Active",
            "total": "Total connectors",
            "webhook": "Webhook alerts"
        },
        "status": {
            "healthy": "Healthy",
            "inactive": "Inactive",
            "stale": "Stale",
            "warning": "Warning"
        },
        "subtitle": "Connect ERP/POS stacks, rotate API keys, and monitor webhooks.",
        "table": {
            "actions": "Actions",
            "lastSync": "Last sync",
            "name": "Connector",
            "never": "Never",
            "status": "Sync",
            "type": "Type",
            "webhook": "Webhook"
        },
        "title": "Distributor integrations",
        "toast": {
            "created": "Connector created",
            "deleted": "Connector deleted",
            "error": "Unable to process request",
            "secret": "Copy the API secret now — it is only shown once",
            "token": "Rotated API credentials",
            "updated": "Connector updated",
            "webhook": "Webhook test recorded"
        },
        "webhook": {
            "failing": "Failing",
            "healthy": "Healthy",
            "missing": "Missing",
            "stale": "Stale",
            "unknown": "Unknown"
        }
    },
    "DistributorManufacturerDetail": {
        "activity": {
            "inbound": "Inbound",
            "outbound": "Outbound"
        },
        "back": "Back to manufacturers",
        "empty": "No data yet.",
        "error": "Unable to load manufacturer detail.",
        "loading": "Loading manufacturer detail…",
        "metrics": {
            "activeRetailers": "Active retailers",
            "inboundQuantity": "Inbound units",
            "inboundValue": "Inbound value",
            "outboundQuantity": "Outbound units",
            "outboundValue": "Outbound value"
        },
        "recentActivity": "Recent activity",
        "subtitle": "No description provided",
        "topRetailers": "Top retailers"
    },
    "DistributorManufacturers": {
        "error": "Unable to load manufacturers.",
        "list": {
            "title": "Manufacturer overview"
        },
        "loading": "Loading manufacturers...",
        "pagination": {
            "next": "Next",
            "prev": "Prev"
        },
        "periodOption": {
            "last_7_days": "Last 7 days",
            "this_month": "This month",
            "this_quarter": "This quarter",
            "this_year": "This year"
        },
        "searchPlaceholder": "Search manufacturers…",
        "stats": {
            "inboundValue": "Inbound value",
            "outboundValue": "Outbound value",
            "totalManufacturers": "Total linked manufacturers"
        },
        "subtitle": "Monitor connected brands, inbound supply, and sell-through performance.",
        "table": {
            "count": "{{count}} total",
            "inbound": "Inbound",
            "manufacturer": "Manufacturer",
            "outbound": "Outbound",
            "retailers": "Active retailers",
            "title": "Manufacturers",
            "units": "{{count}} units",
            "view": "View"
        },
        "title": "Partner manufacturers"
    },
    "DistributorNav": {
        "bestOffers": "Best offers",
        "dashboard": "Dashboard",
        "discounts": "Discounts",
        "imports": "Imports",
        "integrations": "Integrations",
        "logout": "Logout",
        "manufacturers": "Manufacturers",
        "retailers": "Retailers",
        "settings": "Settings",
        "transactions": "Transactions",
        "venues": "Venues"
    },
    "DistributorRetailerDetail": {
        "back": "Back to retailers",
        "empty": "No data yet.",
        "error": "Unable to load retailer detail.",
        "loading": "Loading retailer detail…",
        "manufacturers": "Manufacturers & categories",
        "metrics": {
            "manufacturers": "Linked manufacturers",
            "outboundQuantity": "Outbound units",
            "outboundValue": "Outbound value"
        },
        "recentOrders": "Recent orders",
        "subtitle": "No description provided"
    },
    "DistributorRetailers": {
        "error": "Unable to load retailers.",
        "graph": {
            "allRetailers": "All retailers",
            "error": "Unable to load timeline data.",
            "noData": "No timeline data yet.",
            "period": "Period",
            "periodOption": {
                "last_7_days": "Last 7 days",
                "this_month": "This month",
                "this_quarter": "This quarter",
                "this_year": "This year",
                "yesterday": "Yesterday"
            },
            "retailers": "Retailers"
        },
        "list": {
            "title": "Retailer overview"
        },
        "loading": "Loading retailers...",
        "pagination": {
            "next": "Next",
            "prev": "Prev"
        },
        "searchPlaceholder": "Search retailers…",
        "stats": {
            "outboundQuantity": "Outbound units",
            "outboundValue": "Outbound value",
            "totalRetailers": "Total retailers"
        },
        "subtitle": "Understand which retailers rely on you for each brand/category.",
        "table": {
            "allCategories": "All categories",
            "categories": "Categories",
            "count": "{{count}} total",
            "manufacturers": "Manufacturers",
            "outbound": "Outbound",
            "retailer": "Retailer",
            "title": "Retailers",
            "units": "{{count}} units",
            "view": "View"
        },
        "tabs": {
            "graph": "Timeline",
            "list": "Overview"
        },
        "title": "Retail partners"
    },
    "DistributorSettings": {
        "actions": {
            "addContact": "Add contact",
            "remove": "Remove",
            "rotateToken": "Rotate token",
            "save": "Save settings",
            "saving": "Saving..."
        },
        "api": {
            "active": "API enabled",
            "key": "Current API key",
            "none": "Not generated",
            "secret": "New API secret (copy now)",
            "subtitle": "Manage credentials used by upstream manufacturers.",
            "title": "API tokens"
        },
        "branding": {
            "logo": "Logo URL",
            "primary": "Primary color",
            "secondary": "Secondary color",
            "subtitle": "Align portal colors and contact info with your brand.",
            "supportEmail": "Support email",
            "supportPhone": "Support phone",
            "title": "Branding & support"
        },
        "error": "Unable to load distributor settings.",
        "escalation": {
            "contactEmail": "Email",
            "contactName": "Contact name",
            "contactPhone": "Phone",
            "contacts": "Escalation contacts",
            "policy": "Escalation policy",
            "sla": "Target SLA (hours)",
            "slaPlaceholder": "e.g., 24",
            "subtitle": "Control who is paged when retailers raise incidents.",
            "title": "Escalation policy & SLA"
        },
        "loading": "Loading settings...",
        "subtitle": "Adjust escalation rules, branding, and API access.",
        "title": "Distributor settings",
        "toast": {
            "error": "Unable to save settings",
            "saved": "Settings saved",
            "token": "Generated new API token"
        }
    },
    "DistributorTransactions": {
        "cards": {
            "inbound": "Inbound value",
            "manufacturers": "Manufacturers",
            "outbound": "Outbound value",
            "retailers": "Retailers",
            "transactions": "Transactions",
            "units": "{{count}} units",
            "venues": "Venues"
        },
        "errors": {
            "loadDemographics": "Unable to load transaction statistics.",
            "loadProgress": "Unable to load progress data.",
            "loadStats": "Unable to load distributor transactions."
        },
        "progress": {
            "current": "Current period",
            "outbound": "Outbound comparison",
            "previous": "Previous period"
        },
        "statistics": {
            "empty": "No retailer insights yet.",
            "regions": "Retailer regions",
            "topRetailers": "Top retailer mix",
            "venues": "Venue contribution"
        },
        "subtitle": "Monitor inbound vs outbound value across manufacturers, retailers, and venues.",
        "table": {
            "columns": {
                "date": "Date",
                "inboundValue": "Inbound value",
                "manufacturer": "Manufacturer",
                "outboundValue": "Outbound value",
                "retailer": "Retailer",
                "transactions": "Transactions",
                "venue": "Venue"
            }
        },
        "tabs": {
            "overview": "Overview",
            "progress": "Progress",
            "statistics": "Statistics"
        },
        "title": "Distributor transactions"
    },
    "DistributorVenueDetail": {
        "back": "Back to Venues",
        "error": "Unable to load venue detail.",
        "loading": "Loading venue detail...",
        "stats": {
            "outbound": "Outbound value",
            "units": "units"
        },
        "subtitle": "Performance overview for {{city}} hub",
        "topItems": {
            "empty": "No items shipped yet.",
            "metrics": "{{quantity}} units • {{value}}",
            "title": "Top items"
        }
    },
    "DistributorVenues": {
        "errors": {
            "loadList": "Unable to load venues."
        },
        "subtitle": "Track downstream locations supplied by your network.",
        "table": {
            "columns": {
                "action": "Action",
                "lastActivity": "Last activity",
                "location": "Location",
                "outboundValue": "Outbound value",
                "retailer": "Retailer",
                "venue": "Venue"
            },
            "count": "{{count}} total",
            "search": "Search venues...",
            "view": "Open"
        },
        "title": "Distributor Venues"
    },
    "Edit Campaign Details": "Edit Campaign Details",
    "Imports": {
        "fieldMappingIntro": "We matched your CSV columns to catalogue fields. Review the required fields before continuing.",
        "fieldMappingRequiredTitle": "Product essentials",
        "fieldMappingRequiredHelp": "These three fields are required for every product.",
        "fieldMappingIdentifierTitle": "Product identifier",
        "fieldMappingIdentifierHelp": "Map at least one identifier, such as SKU, EAN, or your system's product ID. Leave the others empty if you do not have them.",
        "fieldMappingRequiredCount": "{{mapped}} / {{total}} required fields mapped",
        "fieldMappingAiSuggestion": "Gemini suggestion · {{confidence}}% confidence",
        "optionalFieldsTitle": "Additional fields",
        "optionalFieldsCount": "{{count}} optional",
        "optionalFieldsHelp": "Map only the data present in your CSV. You can leave the other fields untouched.",
        "template": {
            "title": "Template and guide",
            "description": "Fill in our template. Four columns are required; fill the rest if you have it — an empty cell stops nothing.",
            "download": "Download template (CSV)",
            "guide": "Open the guide",
            "required": "product_name, price, product_url, and sku or external_product_id"
        },
        "unknownColumns": "Columns we do not read are skipped: {{columns}}. That is not an error — your export may carry its own columns.",
        "diff": {
            "title": "What will change",
            "subtitle": "A preview before anything enters the catalogue.",
            "newProducts": "New products",
            "linkingToKnown": "{{count}} will link to an item we already have",
            "brandNew": "{{count}} are entirely new items",
            "existingProducts": "Already present",
            "priceChanges": "Price changes",
            "withoutBarcode": "Without a barcode",
            "invalid": "Invalid rows",
            "newManufacturers": "These manufacturers would be created:",
            "unmappableCategories": "Categories we cannot place:",
            "invalidRows": "Rows that will not be imported",
            "priceChangeList": "Price changes",
            "line": "Line",
            "product": "Product",
            "problem": "Problem",
            "from": "From",
            "to": "To"
        },
        "analysisSubtitle": "Unique entities detected in the file.",
        "analysisTitle": "Analysis summary",
        "analyzeButton": "Analyze file",
        "categories": "Categories",
        "categoryMapping": "Category mapping",
        "suggestCategories": "Suggest Google categories with Gemini",
        "suggestingCategories": "Suggesting categories...",
        "aiCategorySuggestionsRemaining": "{{count}} more categories are queued for AI suggestions. Run this action again to continue.",
        "useAiCategorySuggestion": "Use this suggestion",
        "aiCategorySuggestion": "Gemini suggestion: {{path}} ({{confidence}}%, {{status}}). Review before saving.",
        "createCategory": "Create new category",
        "createManufacturer": "Create new manufacturer",
        "created": "Created",
        "discounts": "Discounts",
        "discountMatches": {
            "matched": "Matched discounts",
            "unmatched": "Unmatched discounts"
        },
        "discountPreview": {
            "title": "Discount preview",
            "row": "Row",
            "externalProductId": "External Product ID",
            "sku": "SKU/GTIN",
            "percentage": "Discount %",
            "value": "Discount value",
            "discountedPrice": "Discounted price",
            "startAt": "Start",
            "endAt": "End",
            "match": "Match",
            "matchYes": "Matched",
            "matchNo": "Not matched"
        },
        "error": "Import error",
        "failed": "Failed",
        "importType": "Import type",
        "loading": "Loading...",
        "manufacturerMapping": "Manufacturer mapping",
        "manufacturers": "Manufacturers",
        "mappingTitle": "Mappings",
        "mappingsSaved": "Mappings saved",
        "missingColumns": "Missing columns",
        "noExternalId": "No external ID",
        "none": "None",
        "pending": "Pending",
        "processedRows": "Processed rows",
        "products": "Products",
        "progressTitle": "Progress",
        "requiredNote": "Make sure the CSV includes required columns before upload.",
        "runButton": "Run import",
        "runTitle": "Run import",
        "running": "Running...",
        "saveMappings": "Save mappings",
        "selectCategory": "Select category",
        "selectManufacturer": "Select manufacturer",
        "skipped": "Skipped",
        "status": "Status",
        "title": "Imports",
        "totalRows": "Total rows",
        "types": {
            "catalog": "Catalog, prices, stock and discounts",
            "discounts": "Discounts only",
            "full": "Full import (items + discounts)",
            "items": "Items import",
            "products": "Products import",
            "stock": "Stock / Inventory"
        },
        "columnsGuide": {
            "title": "CSV column guide",
            "required": "Required:",
            "optional": "Optional:",
            "items": {
                "description": "Use this for importing item catalog data only (without discount creation/update).",
                "required": "manufacturer_name, manufacturer_external_id, category_name, category_external_id, product_name, external_product_id, sku_or_gtin",
                "optional": "price or regular_price, stock_quantity, description/image/metadata fields"
            },
            "full": {
                "description": "Use this for full sync: create/update items and create/update discounts.",
                "required": "manufacturer_name, manufacturer_external_id, category_name, category_external_id, product_name, external_product_id, sku_or_gtin, and discount_percentage or discount_value",
                "optional": "price or regular_price, stock_quantity, discount_start_at, discount_end_at, description/image/metadata fields"
            },
            "discounts": {
                "description": "Use this for discount updates only. Product must already exist in your catalog.",
                "required": "external_product_id or sku_or_gtin, and discount_percentage or discount_value",
                "optional": "price or regular_price (for percentage calculation), discount_start_at, discount_end_at"
            },
            "stock": {
                "description": "Update stock quantities per venue. Products must already exist in your catalog.",
                "required": "external_product_id or sku_or_gtin, stock_quantity",
                "optional": "venue_external_id, venue_name, venue_city, reserved_quantity, stock_status"
            }
        },
        "runSubtitleByType": {
            "catalog": "Create or update products, prices, stock and discounts from one CSV.",
            "discounts": "Apply discounts to existing items in your catalog.",
            "full": "Create/update items and create/update their discounts.",
            "items": "Create or update items and organization SKU data.",
            "stock": "Update inventory levels per venue. Org-level totals are recomputed automatically. Unrecognized venues fall back to org-level stock."
        },
        "unknown": "Unknown",
        "updated": "Updated",
        "uploadButton": "Upload & validate",
        "uploadSubtitle": "Start by selecting a CSV file to validate and preview.",
        "uploadTitle": "Upload CSV",
        "uploading": "Uploading...",
        "validationSubtitle": "Review detected columns and a preview of the first rows.",
        "validationTitle": "Validation results",
        "venueMapping": "Venue mapping",
        "createVenue": "+ Create new venue",
        "selectVenue": "Select or create venue...",
        "autoMatched": "Auto-matched",
        "autoGoogle": "placed via Google taxonomy",
        "autoPerProduct": "resolved per product",
        "venueName": "Venue name",
        "venueCity": "City",
        "venueAddress": "Address",
        "venueNamePlaceholder": "e.g. Zagreb Centar",
        "venueCityPlaceholder": "e.g. Zagreb",
        "venueAddressPlaceholder": "e.g. Ilica 1",
        "venueMatches": {
            "matched": "Matched venues",
            "unmatched": "Unmatched venues"
        }
    },
    "Incentives": "Incentives",
    "Items": {
        "ItemDescription": {
            "description": "Description:",
            "documentation_url": "Documentation URL:",
            "model_number": "Model Number:",
            "month": "{{count}} month",
            "no_description": "No description",
            "no_details": "No item details available",
            "no_technical_specifications": "No technical specifications available",
            "release_year": "Release Year:",
            "technical_specifications": "Technical Specifications",
            "view_documentation": "View Documentation",
            "warranty_coverage": "Warranty Coverage:",
            "warranty_duration": "Warranty Duration:",
            "year": "{{count}} year"
        },
        "Overview": {
            "actions": "Actions",
            "manufacturer_name": "Manufacturer",
            "model_number": "Model Number",
            "organization_sku": "Organization SKU",
            "product_name": "Product Name",
            "serial_number": "Serial Number",
            "status": "Status",
            "status_in_stock": "In stock",
            "status_sold": "Sold",
            "title": "Items Overview",
            "variant_sku": "Variant SKU",
            "view": "View"
        },
        "Performance": {
            "charts": {
                "brandMix": "Revenue by manufacturer",
                "salesTrend": "Sales trend",
                "unitsSeries": "Units sold"
            },
            "emptyState": "No data available for this period.",
            "subtitle": "Monitor how fast items move from inventory to end-users.",
            "summary": {
                "atRiskSkus": "SKUs at risk",
                "avgDaysOnShelf": "Avg. days on shelf",
                "avgSellingPrice": "Avg. selling price",
                "stockOnHand": "Stock on hand",
                "totalRevenue": "Revenue generated",
                "totalUnits": "Units sold"
            },
            "tables": {
                "columns": {
                    "item": "Item",
                    "lastSold": "Last sold",
                    "manufacturer": "Manufacturer",
                    "revenue": "Revenue",
                    "stock": "Stock",
                    "units": "Units"
                },
                "slowMovers": "Slow movers with stock",
                "topSellers": "Best sellers"
            },
            "title": "Performance Insights"
        },
        "SearchFilters": {
            "search_button": "Search",
            "search_placeholder": "Search by Model Number, Serial Number, or Product Name",
            "select_manufacturer": "Select Manufacturer"
        },
        "TransactionsTable": {
            "buyer": "Buyer",
            "counterparty": "Counterparty",
            "counterparty_from": "From",
            "counterparty_to": "To",
            "date": "Date",
            "direction_bought": "Bought by organization",
            "direction_sold": "Sold by organization",
            "n_a": "N/A",
            "no_transactions": "No transactions found",
            "of": "of",
            "page": "Page",
            "payment_method": "Payment Method",
            "price": "Price",
            "price_paid": "Price paid",
            "quantity": "Quantity",
            "revenue": "Revenue",
            "rows_per_page": "Rows per page",
            "sale_value": "Sale value",
            "shipping_cost": "Shipping Cost",
            "title": "Transactions for Item",
            "transaction_type": "Transaction Type",
            "venue": "Venue",
            "warranty": "Warranty"
        },
        "Tutorial": {
            "message": "This tutorial will guide you through the functionalities of the Items section.",
            "title": "Items Tutorial"
        },
        "ViewItem": {
            "Tutorial": {
                "tabs": {
                    "description": {
                        "message": "View detailed information about the item, including its description, manufacturer, and category.",
                        "title": "Description Tab"
                    },
                    "details": {
                        "message": "Explore technical specifications, certifications, and other detailed information about the item.",
                        "title": "Details Tab"
                    },
                    "transactions": {
                        "message": "See all transactions related to this item, including purchase history and details.",
                        "title": "Transactions Tab"
                    },
                    "warranty": {
                        "message": "Review warranty details, including duration, coverage, and claim process.",
                        "title": "Warranty Tab"
                    }
                },
                "welcome_message": "Welcome to the Item View tutorial!"
            },
            "category": "Category",
            "details": {
                "carbon_footprint": "Carbon Footprint",
                "category": "Category",
                "certifications": "Certifications",
                "current_price": "Current Price",
                "discount": "Discount",
                "documentation": "Documentation",
                "icecat_id": "Icecat ID",
                "initial_price": "Initial Price",
                "last_sold_price": "Last Sold Price",
                "material_composition": "Material Composition",
                "model_number": "Model Number",
                "organization_sku": "Organization SKU",
                "recycling_instructions": "Recycling Instructions",
                "release_year": "Release Year",
                "serial_number": "Serial Number",
                "source_id": "Source ID",
                "start_date": "Start Date",
                "technical_specifications": "Technical Specifications",
                "variant_sku": "Variant SKU",
                "view_documentation": "View Documentation"
            },
            "loading": "Loading item details...",
            "manufacturer": "Manufacturer",
            "tabs": {
                "description": "Description",
                "details": "Details",
                "transactions": "Transactions",
                "warranty": "Warranty"
            },
            "warranty": {
                "active": "Active",
                "applicable_to": "Applicable Regions",
                "claim_process": "Claim Process",
                "contact": "Contact",
                "coverage": "Coverage",
                "duration": "Duration",
                "exclusions": "Exclusions",
                "name": "Warranty Name",
                "title": "Warranty Information"
            }
        },
        "Warranty": {
            "columns": {
                "buyer": "Buyer",
                "days": "Days",
                "expiry": "Warranty end",
                "item": "Item",
                "saleDate": "Sale date",
                "venue": "Venue"
            },
            "empty": "No alerts for this bucket.",
            "filters": {
                "limit": "Rows per list",
                "missingActivation": "Activation missing (days)",
                "refresh": "Refresh",
                "withinDays": "Watch next (days)"
            },
            "labels": {
                "daysOverdue": "{{count}} days late",
                "daysRemaining": "{{count}} days left"
            },
            "sections": {
                "expired": {
                    "description": "Items whose warranty already ended.",
                    "title": "Expired warranties"
                },
                "expiringSoon": {
                    "description": "Warranties ending in the next {{days}} days.",
                    "title": "Expiring soon"
                },
                "missingActivation": {
                    "description": "Items sold in the last {{days}} days without a recorded activation.",
                    "title": "Missing activation"
                }
            },
            "subtitle": "Spot warranties at risk before customers call support.",
            "summary": {
                "expired": "Expired",
                "expiringSoon": "Expiring soon",
                "missingActivation": "Missing activation"
            },
            "title": "Warranty Alerts"
        },
        "overview": "Item Overview",
        "performance_insights": "Performance Insights",
        "title": "Items",
        "warranty_alerts": "Warranty Alerts"
    },
    "LoginPage": {
        "Tutorial": {
            "about_app": "This application is designed to streamline the management of loyalty programs for retailers by integrating digital warranties for purchased items and facilitating campaign management for promotions. It offers powerful analytical tools to help users track market trends effectively. By consolidating points management, discounts, and warranties into a single platform, users can eliminate the hassle of handling paper warranties and receipts. This innovative approach ensures a seamless experience, allowing customers to easily manage their loyalty rewards and warranty information—all within one convenient app.",
            "about_app_title": "About the App",
            "credentials_title": "Demo Credentials",
            "demo_credentials": "For testing, you can use: \n - Email: organization1@dwm.com, Password: password \n - Email: organization2@dwm.com, Password: password. \nOrganization 1 has 6k users, and Organization 2 has 4k users, simulating how users from one organization interact with another.",
            "development_message": "If you this icon it means this feature is currently under development.",
            "info_message": "If you ever feel lost or don't understand something, you can click on the info icon to find an explanation of every page and segment.",
            "info_title": "Information",
            "question_message": "If you have any questions about the system or page, just click the question mark icon and write us your question. Someone will answer you soon.",
            "question_title": "Have Questions?",
            "welcome_message": "Welcome to the demo of our application! Feel free to explore and experience the features we have implemented.",
            "welcome_title": "Welcome to GSOFT Demo!"
        },
        "email_label": "Email",
        "forgot_password": "Forgot password",
        "login_button": "Login",
        "login_error": "Failed to login. Check email and password.",
        "or_continue_with": "or continue with",
        "no_account": "No account?",
        "password_label": "Password",
        "register": "Register",
        "subtitle": "Access warranties, loyalty, and analytics with one login.",
        "title": "Welcome back"
    },
    "ManufacturerCompliance": {
        "actions": {
            "add": "Add document",
            "cancel": "Cancel",
            "confirmDelete": "Delete this document?",
            "edit": "Edit",
            "save": "Save",
            "saving": "Saving...",
            "share": "Share"
        },
        "alerts": {
            "expiring": "{{count}} document(s) expire within 30 days"
        },
        "error": "Unable to load compliance documents.",
        "form": {
            "description": "Description",
            "expires": "Expiry date",
            "file": "File URL",
            "title": "Title",
            "type": "Document type"
        },
        "loading": "Loading compliance documents...",
        "share": {
            "description": "Provide comma-separated emails for partners to notify.",
            "placeholder": "partner@example.com, qa@example.com",
            "title": "Share document"
        },
        "status": {
            "draft": "Draft",
            "shared": "Shared"
        },
        "subtitle": "Track DPP bundles, regulatory docs, and share expiring certificates.",
        "table": {
            "actions": "Actions",
            "doc": "Document",
            "expires": "Expires",
            "status": "Status",
            "type": "Type"
        },
        "title": "Compliance & Certificates",
        "toast": {
            "created": "Document added",
            "deleted": "Document removed",
            "error": "Action failed",
            "shared": "Document shared",
            "updated": "Document updated"
        },
        "types": {
            "certificate": "Certificate",
            "dpp": "DPP",
            "regulatory": "Regulatory"
        }
    },
    "ManufacturerDashboard": {
        "actions": "Action Items",
        "activeDistributors": "Active Distributors",
        "activeRetailers": "Active Retailers",
        "activeWarranties": "Active Warranties",
        "avgSellThrough": "Avg Sell-Through Value",
        "avgTtr": "Avg Time to Repair",
        "campaignsRunning": "Campaigns Running",
        "error": "Unable to load manufacturer dashboard data.",
        "loading": "Loading manufacturer metrics...",
        "noActions": "No immediate actions required.",
        "openTickets": "Open Service Tickets",
        "returns": "Returns",
        "returnsRate": "Returns Rate",
        "sellIn": "Sell-In Value",
        "sellInQuantity": "Sell-In Units",
        "sellInTransactions": "Sell-In Transactions",
        "sellThrough": "Sell-Through Value",
        "sellThroughQuantity": "Sell-Through Units",
        "sellThroughRate": "Sell-Through Rate",
        "sellThroughTransactions": "Sell-Through Transactions",
        "title": "Manufacturer Dashboard",
        "topBuyers": "Top Buyers",
        "topRetailerRegions": "Top Retailer Regions",
        "topRetailers": "Top Retailers",
        "topSkus": "Top SKUs",
        "topUserRegions": "Top User Regions",
        "totalSkus": "Total SKUs",
        "uniqueBuyers": "Unique Buyers",
        "warrantyActivation": "Warranty Activation Rate"
    },
    "ManufacturerDiscounts": {
        "empty": "No manufacturer discounts recorded yet.",
        "error": "Unable to load manufacturer discounts.",
        "filters": {
            "all": "All"
        },
        "importButton": "Import discounts CSV",
        "importSoon": "CSV import will be available soon.",
        "status": {
            "active": "Active",
            "expired": "Expired",
            "upcoming": "Upcoming"
        },
        "subtitle": "Review incentives deployed to distributors and retailers worldwide.",
        "summary": {
            "active": "Active",
            "expired": "Expired",
            "upcoming": "Upcoming"
        },
        "table": {
            "discount": "Discount",
            "end": "Valid until",
            "global": "All venues",
            "product": "Product",
            "status": "Status",
            "venue": "Venue"
        },
        "title": "Manufacturer discounts"
    },
    "ManufacturerDistributorDetail": {
        "activity": {
            "columns": {
                "date": "Date",
                "direction": "Direction",
                "quantity": "Quantity",
                "value": "Value"
            },
            "direction": {
                "inbound": "Inbound from manufacturer",
                "outbound": "Outbound to partners"
            },
            "empty": "No recent transactions with this distributor.",
            "title": "Recent activity"
        },
        "back": "Back to Distributors",
        "contact": {
            "notAvailable": "Not available",
            "title": "Contact info"
        },
        "error": "Unable to load distributor detail.",
        "loading": "Loading distributor detail...",
        "stats": {
            "inbound": "Inbound purchases",
            "inventory": "Units in channel",
            "outbound": "Outbound sales",
            "sold": "Units sold",
            "units": "units",
            "venues": "Venues"
        },
        "subtitle": "End-to-end visibility into this distributor relationship.",
        "venues": {
            "empty": "No venues linked to this distributor yet.",
            "title": "Venues"
        }
    },
    "ManufacturerDistributors": {
        "errors": {
            "loadList": "Unable to load distributors.",
            "loadStats": "Unable to load distributor analytics."
        },
        "stats": {
            "cards": {
                "distributors": "Active distributors",
                "inbound": "Inbound value",
                "inventory": "Units in channel",
                "outbound": "Outbound value",
                "sold": "Units sold",
                "venues": "Attached venues"
            },
            "countries": {
                "empty": "No countries recorded.",
                "title": "Top countries"
            },
            "error": "Unable to load distributor analytics.",
            "loading": "Loading distributor analytics...",
            "trend": {
                "empty": "No movement recorded this week.",
                "inbound": "Inbound",
                "outbound": "Outbound",
                "title": "Value trend (EUR)"
            }
        },
        "subtitle": "Track upstream partners, coverage, and channel momentum.",
        "table": {
            "columns": {
                "action": "Action",
                "country": "Country",
                "distributor": "Distributor",
                "inbound": "Inbound value",
                "inventory": "Units in channel",
                "outbound": "Outbound value",
                "sold": "Units sold",
                "venues": "Venues"
            },
            "notAvailable": "N/A",
            "search": "Search distributors...",
            "view": "Open"
        },
        "tabs": {
            "list": "List",
            "stats": "Analytics"
        },
        "title": "Distributors"
    },
    "ManufacturerImportExport": {
        "actions": {
            "startExport": "Queue export",
            "startImport": "Queue import",
            "submitting": "Submitting..."
        },
        "error": "Unable to load import/export jobs.",
        "exports": {
            "requestSubtitle": "Generate downloadable packages for your downstream systems.",
            "requestTitle": "Schedule export"
        },
        "form": {
            "fileName": "File name (optional)",
            "sourceName": "Source name",
            "sourceUrl": "Source URL",
            "type": "Type"
        },
        "history": {
            "exports": "Export history",
            "imports": "Import history"
        },
        "imports": {
            "requestSubtitle": "Upload SKU, warranty, or distributor data JSON/CSV via secure link.",
            "requestTitle": "Start new import"
        },
        "loading": "Loading jobs...",
        "status": {
            "completed": "Completed",
            "failed": "Failed",
            "pending": "Pending",
            "processing": "Processing"
        },
        "subtitle": "Manage SKU catalogs, warranties, and distributor mapping exchanges.",
        "table": {
            "date": "Date",
            "download": "Download",
            "file": "File",
            "progress": "Progress",
            "source": "Source",
            "status": "Status",
            "type": "Type"
        },
        "tabs": {
            "exports": "Exports",
            "imports": "Imports"
        },
        "title": "Imports & Exports",
        "toast": {
            "error": "Unable to complete the request",
            "exportCreated": "Export requested",
            "importCreated": "Import queued"
        },
        "types": {
            "distributor": "Distributor mappings",
            "sku": "SKU catalog",
            "warranty": "Warranty templates"
        }
    },
    "ManufacturerIntegrations": {
        "actions": {
            "add": "Add connector",
            "cancel": "Cancel",
            "confirmDelete": "Remove this connector?",
            "save": "Save",
            "saving": "Saving...",
            "testWebhook": "Test webhook"
        },
        "addTitle": "Add connector",
        "detail": {
            "apiKey": "API key",
            "apiSecret": "API secret (copy now)",
            "endpoint": "API endpoint",
            "sync": "Sync interval",
            "type": "Connector type",
            "webhookSecret": "Webhook secret",
            "webhookUrl": "Webhook URL"
        },
        "editTitle": "Edit connector",
        "error": "Unable to load integrations.",
        "form": {
            "custom": "Custom",
            "email": "Contact email",
            "endpoint": "Endpoint URL",
            "isActive": "Integration active",
            "name": "Name",
            "sync": "Sync interval",
            "syncDaily": "Daily",
            "syncHourly": "Hourly",
            "syncRealtime": "Real time",
            "type": "Type",
            "webhook": "Webhook URL"
        },
        "loading": "Loading integrations...",
        "stats": {
            "active": "Active",
            "total": "Total connectors",
            "webhook": "Webhook alerts"
        },
        "status": {
            "healthy": "Healthy",
            "inactive": "Inactive",
            "stale": "Stale",
            "warning": "Warning"
        },
        "subtitle": "Connect ERP/POS/CRM stacks, monitor webhooks, and manage credentials.",
        "table": {
            "actions": "Actions",
            "lastSync": "Last sync",
            "name": "Connector",
            "never": "Never",
            "status": "Sync",
            "type": "Type",
            "webhook": "Webhook"
        },
        "title": "Integrations workspace",
        "toast": {
            "created": "Connector created",
            "deleted": "Connector deleted",
            "error": "Unable to process request",
            "secret": "Copy the API secret now — it is only shown once",
            "token": "Rotated API credentials",
            "updated": "Connector updated",
            "webhook": "Webhook test recorded"
        },
        "webhook": {
            "failing": "Failing",
            "healthy": "Healthy",
            "missing": "Missing",
            "stale": "Stale",
            "unknown": "Unknown"
        }
    },
    "ManufacturerNav": {
        "compliance": "Compliance",
        "dashboard": "Dashboard",
        "discounts": "Discounts",
        "distributors": "Distributors",
        "imports": "Imports/Exports",
        "integrations": "Integrations",
        "logout": "Logout",
        "productApprovals": "Product Approvals",
        "products": "Products",
        "retailers": "Retailers",
        "settings": "Settings",
        "support": "Support",
        "transactions": "Transactions",
        "venues": "Venues",
        "warranties": "Warranties"
    },
    "ManufacturerProducts": {
        "create": {
            "cancel": "Cancel",
            "fields": {
                "description": "Description",
                "documentation_url": "Documentation URL",
                "initial_price": "Initial Price (€)",
                "model_number": "Model Number",
                "product_name": "Product Name",
                "release_year": "Release Year",
                "warranty_coverage": "Warranty Coverage",
                "warranty_duration": "Warranty Duration (months)"
            },
            "save": "Create Product",
            "saving": "Saving...",
            "title": "Create Manufacturer Product"
        },
        "detail": {
            "back": "Back to Products",
            "cards": {
                "sellInUnits": "Sell-In Units",
                "sellInValue": "Sell-In Value",
                "sellThroughUnits": "Sell-Through Units",
                "sellThroughValue": "Sell-Through Value"
            },
            "identifierSku": "SKU",
            "identifierType": "Type",
            "identifierValue": "Value",
            "identifiers": "Identifiers",
            "insights": "Sales Insights",
            "noIdentifiers": "No identifiers yet.",
            "noTransactions": "No transactions recorded for this period.",
            "noVariants": "No variants defined yet.",
            "periodNote": "Filtered by selected period",
            "sellInSeries": "Sell-In Qty",
            "sellThroughSeries": "Sell-Through Qty",
            "topBuyers": "Top Buyers",
            "topRetailerRegions": "Top Retailer Regions",
            "topRetailers": "Top Retailers",
            "topUserRegions": "Top User Regions",
            "transactions": "Transaction Breakdown",
            "transactions_customers": "Customers",
            "transactions_distributors": "Distributors",
            "transactions_retailers": "Retailers",
            "units": "{{count}} units",
            "variantAttributes": "Attributes",
            "variantModel": "Model",
            "variantSku": "SKU",
            "variants": "Variants"
        },
        "errors": {
            "createFailed": "Failed to create product.",
            "fetchFailed": "Unable to load products."
        },
        "newProduct": "New Product",
        "notifications": {
            "created": "Product created successfully!"
        },
        "searchPlaceholder": "Search by SKU or name...",
        "subtitle": "Manage your SKUs, track sell-in/out, and drill into performance.",
        "table": {
            "columns": {
                "actions": "Actions",
                "product": "Product",
                "sellIn": "Sell-In Units",
                "sellThrough": "Sell-Through Units",
                "sellThroughValue": "Sell-Through Value",
                "sku": "SKU"
            },
            "view": "View"
        },
        "tabs": {
            "catalog": "Catalog",
            "transactions": "Transactions"
        },
        "title": "Product Catalog",
        "transactions": {
            "customers": "Customers",
            "retailers": "Retailers",
            "subtitle": "Sell-in and sell-through totals by period.",
            "title": "Manufacturer Transactions"
        }
    },
    "ManufacturerRetailerDetail": {
        "back": "Back to Retailers",
        "contact": {
            "notAvailable": "Not provided",
            "title": "Contacts & HQ"
        },
        "error": "Unable to load retailer detail.",
        "items": {
            "columns": {
                "product": "Product",
                "purchased": "Purchased",
                "sku": "SKU",
                "sold": "Sold"
            },
            "empty": "No transactions recorded for this retailer.",
            "title": "Manufacturer items performance"
        },
        "loading": "Loading retailer detail...",
        "stats": {
            "buyValue": "Buy value",
            "inventory": "Units in stock",
            "sellValue": "Sell value",
            "sold": "Units sold",
            "units": "units"
        },
        "subtitle": "Full visibility into this retailer relationship.",
        "venues": {
            "empty": "No venues connected.",
            "title": "Venues"
        }
    },
    "ManufacturerRetailers": {
        "errors": {
            "loadGraph": "Unable to load graph data.",
            "loadList": "Unable to load retailers."
        },
        "graph": {
            "allRetailers": "All retailers",
            "buyLabel": "Retailers Buy",
            "noData": "No activity recorded for the selected filters.",
            "period": "Period",
            "periodOption": {
                "last_7_days": "Last 7 days",
                "this_month": "This Month",
                "this_quarter": "This Quarter",
                "this_year": "This Year",
                "yesterday": "Yesterday"
            },
            "retailers": "Retailers",
            "sellLabel": "Retailers Sell"
        },
        "subtitle": "Monitor who buys from you, how they perform, and drill into transaction trends.",
        "table": {
            "columns": {
                "action": "Action",
                "inventory": "Units in stock",
                "retailer": "Retailer",
                "sellInValue": "Buy value",
                "sellThroughValue": "Sell value",
                "sold": "Units sold",
                "venues": "Venues"
            },
            "search": "Search retailers...",
            "view": "Open"
        },
        "tabs": {
            "graph": "Retailers Graph",
            "list": "Retailers",
            "venues": "Venues"
        },
        "title": "Retail partners",
        "venues": {
            "columns": {
                "lastActivity": "Last activity",
                "location": "Location",
                "retailer": "Retailer",
                "sellThroughValue": "Sell-through value",
                "venue": "Venue"
            },
            "errors": {
                "loadList": "Unable to load retailer venues."
            },
            "search": "Search venues or retailers..."
        }
    },
    "ManufacturerSettings": {
        "actions": {
            "add": "Add",
            "addContact": "Add contact",
            "remove": "Remove",
            "rotateToken": "Rotate token",
            "save": "Save settings",
            "saving": "Saving..."
        },
        "api": {
            "active": "API enabled",
            "key": "Current API key",
            "none": "Not generated",
            "secret": "New API secret (copy now)",
            "subtitle": "Manage REST credentials used by ERP/POS integrations.",
            "title": "API tokens"
        },
        "branding": {
            "logo": "Logo URL",
            "primary": "Primary color",
            "secondary": "Secondary color",
            "subtitle": "Align portal colors and support touchpoints with your brand.",
            "supportEmail": "Support email",
            "supportPhone": "Support phone",
            "title": "Branding & support"
        },
        "error": "Unable to load manufacturer settings.",
        "escalation": {
            "contactEmail": "Email",
            "contactName": "Contact name",
            "contactPhone": "Phone",
            "contacts": "Escalation contacts",
            "policy": "Escalation policy",
            "sla": "Target SLA (hours)",
            "slaPlaceholder": "e.g., 24",
            "subtitle": "Define who is paged and what response time you promise partners.",
            "title": "Escalation policy & SLA"
        },
        "loading": "Loading settings...",
        "subtitle": "Tune escalation flows, SLA targets, branding, and API access.",
        "title": "Manufacturer settings",
        "toast": {
            "error": "Unable to save settings",
            "saved": "Settings saved",
            "token": "Generated new API token"
        }
    },
    "ManufacturerSupport": {
        "errors": {
            "loadClaims": "Unable to load claims.",
            "loadStats": "Unable to load support stats.",
            "updateClaim": "Unable to update claim."
        },
        "filters": {
            "allStatuses": "All statuses",
            "searchPlaceholder": "Search claims..."
        },
        "notifications": {
            "statusUpdated": "Claim status updated."
        },
        "stats": {
            "avgResolution": "Avg. resolution",
            "days": "days",
            "open": "Open claims",
            "resolved": "Resolved"
        },
        "status": {
            "inProgress": "In progress",
            "resolved": "Resolved",
            "submitted": "Submitted"
        },
        "subtitle": "Track warranty claims, assignments, and service center performance.",
        "table": {
            "claim": "Claim",
            "claimDate": "Claim date",
            "item": "Item",
            "serial": "Serial",
            "status": "Status"
        },
        "title": "Support & Claims"
    },
    "ManufacturerTransactions": {
        "cards": {
            "buyers": "Distinct buyers",
            "retailers": "Retail partners",
            "sellIn": "Sell-in value",
            "sellThrough": "Sell-through value",
            "transactions": "Transactions",
            "units": "{{count}} units",
            "venues": "Active venues"
        },
        "errors": {
            "loadDemographics": "Unable to load statistics.",
            "loadProgress": "Unable to load progress data.",
            "loadStats": "Unable to load transactions."
        },
        "progress": {
            "current": "Current period",
            "previous": "Previous period",
            "sellThrough": "Sell-through comparison"
        },
        "statistics": {
            "age": "Buyer age groups",
            "buyers": "Buyers",
            "countries": "Buyer countries",
            "gender": "Buyer gender distribution",
            "venues": "Venue contribution"
        },
        "subtitle": "Analyze sell-in vs sell-through across retailers, venues, and SKUs.",
        "table": {
            "columns": {
                "date": "Date",
                "retailer": "Retailer",
                "sellInValue": "Sell-in value",
                "sellThroughValue": "Sell-through value",
                "transactions": "Transactions",
                "venue": "Venue"
            }
        },
        "tabs": {
            "overview": "Overview",
            "progress": "Progress",
            "statistics": "Statistics"
        },
        "title": "Transactions"
    },
    "ManufacturerVenueDetail": {
        "back": "Back to Venues",
        "contact": {
            "title": "Contact & location"
        },
        "error": "Unable to load venue detail.",
        "lastActivity": "Last activity: {{date}}",
        "loading": "Loading venue detail...",
        "stats": {
            "sellIn": "Sell-in value",
            "sellThrough": "Sell-through value",
            "units": "units"
        },
        "subtitle": "Performance overview for {{city}} showroom",
        "topItems": {
            "empty": "No items sold yet.",
            "metrics": "{{sell}} units • {{value}}",
            "title": "Top items"
        }
    },
    "ManufacturerVenues": {
        "create": {
            "button": "New Venue",
            "cancel": "Cancel",
            "error": "Unable to create venue.",
            "errors": {
                "nameRequired": "Name is required."
            },
            "fields": {
                "address": "Address",
                "city": "City",
                "description": "Description",
                "email": "Email",
                "name": "Venue name",
                "phone": "Phone",
                "website": "Website"
            },
            "save": "Create Venue",
            "saving": "Saving...",
            "success": "Venue created successfully.",
            "title": "Add Venue"
        },
        "errors": {
            "loadList": "Unable to load venues."
        },
        "subtitle": "Manage your own venue footprint and monitor sell-through per location.",
        "table": {
            "columns": {
                "action": "Action",
                "lastActivity": "Last activity",
                "location": "Location",
                "sellThroughValue": "Sell-through value",
                "venue": "Venue"
            },
            "search": "Search venues...",
            "view": "Open"
        },
        "title": "Manufacturer Venues"
    },
    "ManufacturerWarranties": {
        "actions": {
            "newTemplate": "New template"
        },
        "active": {
            "activated": "Activated",
            "buyer": "Buyer",
            "expires": "Expires",
            "item": "Item",
            "serial": "Serial"
        },
        "confirmDelete": "Delete this template?",
        "errors": {
            "deleteTemplate": "Unable to delete template.",
            "loadActive": "Unable to load active warranties.",
            "loadFormMeta": "Unable to load form data.",
            "loadStats": "Unable to load warranty stats.",
            "loadTemplates": "Unable to load templates.",
            "saveTemplate": "Unable to save template."
        },
        "modal": {
            "createTitle": "Create warranty template",
            "editTitle": "Edit warranty template",
            "fields": {
                "active": "Active",
                "anyItem": "Any item",
                "category": "Category",
                "claimProcess": "Claim process (one per line)",
                "description": "Description",
                "duration": "Duration (months)",
                "item": "Specific SKU",
                "name": "Name",
                "terms": "Terms (one per line)",
                "type": "Template type"
            }
        },
        "notifications": {
            "created": "Template created.",
            "deleted": "Template deleted.",
            "updated": "Template updated."
        },
        "stats": {
            "active": "Active warranties",
            "expiring": "Expiring (30d)",
            "templates": "Templates"
        },
        "subtitle": "Define warranty templates and track active coverage for your products.",
        "table": {
            "actions": "Actions",
            "duration": "Duration",
            "months": "months",
            "searchPlaceholder": "Search templates...",
            "status": "Status",
            "template": "Template",
            "type": "Type"
        },
        "tabs": {
            "active": "Active warranties",
            "templates": "Templates"
        },
        "title": "Warranties"
    },
    "Approvals": {
        "title": "Registration requests",
        "refresh": "Refresh",
        "empty": "No pending requests.",
        "company": "Company",
        "status": "Status",
        "status_pending": "Awaiting email confirmation",
        "status_verified": "Email confirmed",
        "requestedType": "Requested type",
        "requestedPlan": "Requested plan",
        "taxId": "Tax ID / VAT",
        "registered": "Registered",
        "approve": "Approve",
        "reject": "Reject",
        "cancel": "Cancel",
        "plan": "Plan",
        "confirmType": "Confirm type",
        "typeHint": "The applicant only declares the type. Manufacturer and distributor carry permissions, so we confirm them manually.",
        "taxVerified": "Tax ID verified",
        "reason": "Rejection reason",
        "reasonPlaceholder": "e.g. tax ID does not match the company name",
        "reasonHint": "A reason is required — without one, a rejection turns into a support ticket.",
        "reasonRequired": "Please enter a rejection reason.",
        "approved": "Registration approved.",
        "rejected": "Registration rejected.",
        "actionFailed": "The action could not be completed.",
        "loadFailed": "Requests could not be loaded right now."
    },
    "VerifyEmail": {
        "approved_title": "Email confirmed",
        "approved_message": "Your account is active. You can sign in and connect your catalogue.",
        "verified_title": "Email confirmed",
        "verified_message": "Thanks, your address is confirmed.",
        "awaiting_review_title": "Email confirmed",
        "awaiting_review_message": "We are reviewing your registration and will get back to you by email, usually the same working day.",
        "invalid_title": "Link is not valid",
        "invalid_message": "The link has expired or was already used. Request a new confirmation email.",
        "toLogin": "Sign in"
    },
    "CatalogSources": {
        "mapping": "Field mapping",
        "mappingHint": "Connect the feed's fields to ours. Recognised fields are suggested automatically; AI suggestions are optional and every mapping can be reviewed before saving.",
        "notMapped": "— not mapped —",
        "identityRequired": "Map at least one stable source ID, SKU, or GTIN/EAN/UPC. Products without a barcode can be staged when a stable ID or SKU is present.",
        "aiMappingAction": "Suggest mapping with AI",
        "aiMappingRunning": "AI is analyzing fields…",
        "aiMappingReady": "AI suggestions are ready ({{count}} fields). Review them before saving.",
        "aiMappingFailed": "AI field suggestions failed.",
        "field_ean": "EAN / barcode",
        "field_external_id": "External product ID",
        "field_parent_external_id": "Parent product ID",
        "field_external_variant_id": "Variant ID",
        "field_sku": "SKU",
        "field_product_name": "Product name",
        "field_manufacturer_name": "Manufacturer",
        "field_category_name": "Category",
        "field_price": "Price",
        "field_sale_price": "Sale price",
        "field_discount_percentage": "Discount (%)",
        "field_discount_value": "Discount amount",
        "field_discount_start_at": "Discount starts",
        "field_discount_end_at": "Discount ends",
        "field_currency": "Currency",
        "field_stock": "Stock",
        "field_stock_status": "Availability status",
        "field_url": "Link",
        "field_image_url": "Image",
        "field_warranty_months": "Warranty (months)",
        "title": "Catalog sources",
        "add": "Add source",
        "edit": "Edit",
        "updated": "Source updated.",
        "managedByPlugin": "Managed by plugin",
        "empty": "No sources yet. Add a feed and your catalogue syncs automatically.",
        "adapter": "Source type",
        "name": "Name",
        "defaultName": "Catalog source",
        "frequency": "Frequency",
        "frequencyHint": "Your plan allows up to {{max}}x per day.",
        "runAt": "Exact times",
        "runAtHint": "Optional, comma-separated, e.g. 08:00, 16:00.",
        "planLocked": "requires a higher plan",
        "perDay": "{{n}}x per day",
        "test": "Test connection",
        "testing": "Testing...",
        "testOk": "Feed read successfully - {{total}} products found.",
        "testFailed": "The feed could not be read.",
        "testFirst": "Test the connection before saving - you see what we read straight away.",
        "detectedFields": "Detected fields",
        "sample": "Sample",
        "save": "Save",
        "cancel": "Cancel",
        "created": "Source added. Enable daily sync when you're ready.",
        "saveFailed": "The source could not be saved.",
        "invalidConfig": "Please check the values you entered.",
        "syncNow": "Sync now",
        "dailyEnabledLabel": "Daily sync enabled",
        "dailyEnabled": "Daily sync is enabled. The first sync has been queued.",
        "dailyDisabled": "Daily sync is paused.",
        "nextRun": "Next sync",
        "syncDone": "Synced: {{items}} products ({{used}}/{{allowed}} today).",
        "syncQueued": "Sync queued ({{used}}/{{allowed}} today).",
        "syncFailed": "The sync failed.",
        "quotaSpent": "Daily quota spent ({{used}}/{{allowed}}). Try tomorrow or upgrade your plan.",
        "history": "History",
        "noRuns": "No runs yet.",
        "runsFailed": "History could not be loaded.",
        "delete": "Delete",
        "deleted": "Source deleted.",
        "deleteFailed": "The source could not be deleted.",
        "confirmDelete": "Delete source {{name}}? The catalogue stays, but stops refreshing.",
        "items": "products",
        "waitingFirstRun": "Waiting for first sync",
        "loadFailed": "Sources could not be loaded right now.",
        "limitsNote": "Plan: up to {{perDay}}x per day (used {{used}} today), up to {{products}} products.",
        "draft": "Daily sync is paused. You can enable it below or run a manual sync.",
        "scheduleActive": "Automatic refresh is enabled",
        "schedulePaused": "Automatic refresh is disabled",
        "progress": "Catalog processing",
        "progressHint": "Actual product counts by status, refreshed every 10 seconds.",
        "live": "Live · 10 sec",
        "readCategories": "Read categories",
        "reviewCategories": "Category mappings",
        "progressLabels": {
            "published": "In catalog",
            "waiting": "Waiting",
            "queued": "Queued",
            "running": "Processing",
            "review": "Needs review",
            "failed": "Failed"
        },
        "status_ok": "OK",
        "status_partial": "Partial",
        "status_failed": "Failed",
        "status_timeout": "Timed out",
        "status_running": "Running",
        "status_skipped": "Skipped",
        "status_never": "Never run",
        "outcome_created": "New products",
        "outcome_price_updated": "Price changed",
        "outcome_stock_updated": "Stock changed",
        "outcome_url_updated": "Link changed",
        "outcome_discount_created": "New offer",
        "outcome_discount_updated": "Offer updated",
        "outcome_delisted": "Delisted",
        "outcome_reactivated": "Relisted",
        "outcome_unchanged": "Unchanged",
        "outcome_filtered": "Filtered by policy"
    },
    "Plan": {
        "privateOffer": "Special price",
        "title": "My plan",
        "currentPlan": "Current plan",
        "free": "Free",
        "perMonth": "mo",
        "perYear": "yr",
        "unlimited": "Unlimited",
        "included": "Included",
        "notIncluded": "Not included",
        "renewsOn": "Renews on",
        "upgradeTo": "Next plan",
        "choosePlan": "Choose a plan",
        "upgrade": "Upgrade",
        "changePlan": "Change plan",
        "differentLimits": "This plan has different limits. Compare them below before changing.",
        "compareBelow": "Compare the selected plan's price and limits with your current plan below.",
        "paymentUnavailable": "Online plan payments are not configured. Contact support.",
        "paymentStarting": "Starting payment...",
        "paymentFailed": "Payment could not be completed.",
        "paymentNotConfirmed": "Payment has not been confirmed yet. Check the billing page before trying again.",
        "paymentReceived": "Payment received. Your plan is updating now.",
        "paymentActivationPending": "Payment is confirmed. Plan activation is still processing; refresh this page shortly.",
        "existingStripeSubscription": "Plan changes for an active Stripe subscription are not self-service yet. Contact support.",
        "usageTitle": "Usage",
        "usageSubtitle": "See how much you use and how limits differ between plans.",
        "currentLimit": "Your limit",
        "featuresTitle": "Included features",
        "entitlement": "Entitlement",
        "used": "Used",
        "limit": "Limit",
        "usageShare": "Share",
        "liveNote": "Products, locations and loyalty members are counted from current state.",
        "loadFailed": "Plan details could not be loaded right now."
    },
    "Stats": {
        "title": "View statistics",
        "loading": "Loading…",
        "loadFailed": "Statistics are unavailable right now.",
        "noData": "No views were recorded in the selected period.",
        "backendUpdateRequired": "The detailed chart will be available after the backend is updated.",
        "rangeLabel": "Period",
        "granularityLabel": "Group by",
        "range_7": "Last 7 days",
        "range_30": "Last 30 days",
        "range_90": "Last 90 days",
        "range_365": "Last 12 months",
        "byDay": "Daily",
        "byWeek": "Weekly",
        "byMonth": "Monthly",
        "viewed": "Views",
        "clicks": "Retailer visits",
        "impressions": "Impressions",
        "detailViews": "Detail opens",
        "discountImpressions": "Discount impressions",
        "discountDetailViews": "Discount detail opens",
        "discountClicks": "Visits to retailer site",
        "catalogImpressions": "Catalog item impressions",
        "catalogDetailViews": "Catalog item detail opens",
        "catalogClicks": "Visits to retailer site",
        "clickRate": "Retailer visit rate",
        "discountClickRate": "Visits to retailer site per impression",
        "reach": "Reach this month",
        "chartTitle": "Impressions, detail opens, and clicks over time",
        "chartDiscountTitle": "Discount engagement",
        "chartCatalogTitle": "Catalog engagement",
        "chartNote": "An impression is counted when a card is visible, an opening when someone opens its details, and a departure when they go to the retailer offer. App and storefront activity is combined. Older web data combined card displays and detail opens, so it is included in the historical impression total.",
        "surfaceApp": "App",
        "surfaceStorefront": "Storefront",
        "topItems": "Most engaged offers",
        "product": "Product"
    },
    "PartnerReferral": {
        "title": "Referral partner",
        "heading": "Partner referral code",
        "description": "Enter the referral code of the partner that introduced your business to DigiWarranty. The code is assigned to your organization and can be changed until the first paid subscription is recorded.",
        "codeLabel": "Referral code",
        "save": "Save code",
        "saved": "Referral partner saved.",
        "locked": "This referral is locked since {date}, after the first paid subscription.",
        "terms": "A referral is not a discount code. Partner commission is calculated only after a retailer subscription payment succeeds. Without a referral code, no partner is attributed.",
        "loadError": "Could not load referral settings.",
        "saveError": "Could not save the referral code. Check the code and try again."
    },
    "PartnerDashboard": {
        "loading": "Loading partner workspace…",
        "loadError": "The partner workspace could not be loaded.",
        "retry": "Retry",
        "dashboardTitle": "Partner dashboard",
        "partnerProgram": "Sales partner workspace",
        "welcome": "Welcome, {{name}}",
        "overviewIntro": "Track the retailers you introduce, their subscription status and your commission activity.",
        "referralCode": "Your referral code",
        "copyCode": "Copy code",
        "copied": "Referral code copied.",
        "copyError": "Could not copy the code. Select and copy it manually.",
        "referredRetailers": "Referred retailers",
        "referredRetailersHint": "Organizations attributed to your partner profile",
        "activeSubscriptions": "Active subscriptions",
        "activeSubscriptionsHint": "Retailers with an active paid subscription",
        "installations": "Plugin installations",
        "installationsHint": "Tracked installations from attributed retailers",
        "pendingCommission": "Commission pending",
        "paidCommission": "Commission paid",
        "reversalDue": "Refund adjustment due",
        "reversalDueAmount": "Commission to recover",
        "noCommission": "No commission yet",
        "noReversal": "No adjustments due",
        "commissionRate": "{{rate}}% recurring commission",
        "commissionExplanation": "Commission is recorded after a retailer payment succeeds. Free accounts and unpaid trials do not earn commission; refunds may reduce or reverse it.",
        "payoutSetupTitle": "Payout details",
        "payoutSetupText": "Add a payout contact email so the team can coordinate partner payments.",
        "managePayout": "Manage payout settings",
        "retailersTitle": "Retailers",
        "installationsTitle": "Plugin installations",
        "commissionsTitle": "Commissions",
        "teamTitle": "Team members",
        "teamReadOnly": "You can view the partner team, but only organization administrators can add or remove members.",
        "settingsTitle": "Partner settings",
        "payoutTitle": "Payout contact",
        "payoutDescription": "Set the email address used for partner payout coordination. Payment details are handled separately with the DigiWarranty team.",
        "commissionRateLabel": "Commission rate",
        "accountStatus": "Partner status",
        "payoutEmail": "Payout contact email",
        "payoutEmailPlaceholder": "payments@example.com",
        "payoutEmailHelp": "Only partner administrators can view and update payout settings.",
        "adminOnlySettings": "Payout settings are available to partner organization administrators.",
        "settingsSaved": "Payout contact saved.",
        "saveError": "Could not save payout settings. Please try again.",
        "save": "Save",
        "saving": "Saving…",
        "addMemberTitle": "Add a team member",
        "addMemberText": "Create a login for a colleague who needs access to this partner workspace.",
        "firstName": "First name",
        "lastName": "Last name",
        "email": "Email",
        "temporaryPassword": "Initial password",
        "temporaryPasswordHelp": "Share the initial password through a secure channel. The team member can use account recovery if they need to reset it.",
        "addMember": "Add member",
        "adding": "Adding…",
        "memberAdded": "Team member added.",
        "memberAddError": "Could not add team member.",
        "memberRemoved": "Team member removed.",
        "memberRemoveError": "Could not remove team member.",
        "removeConfirm": "Remove this team member from the partner organization? Their DigiWarranty account will remain.",
        "remove": "Remove access",
        "actions": "Actions",
        "name": "Name",
        "added": "Added",
        "retailer": "Retailer",
        "plan": "Plan",
        "subscriptionPayment": "Subscription payment",
        "refunded": "Refunded",
        "rate": "Rate",
        "noPaidPlan": "No paid plan",
        "subscription": "Subscription",
        "active": "Active",
        "inactive": "Inactive",
        "account": "Account",
        "periodEnd": "Current period ends",
        "platform": "Platform",
        "store": "Store",
        "version": "Plugin version",
        "status": "Status",
        "lastSeen": "Last seen",
        "commission": "Commission",
        "netCommission": "Commission after refunds",
        "date": "Date",
        "paidAt": "Paid at",
        "statuses": {
            "active": "Active",
            "approved": "Approved",
            "cancelled": "Cancelled",
            "connected": "Connected",
            "inactive": "Inactive",
            "installed": "Installed",
            "onboarding": "Setup in progress",
            "paid": "Paid",
            "partially_refunded": "Partially refunded",
            "past_due": "Payment overdue",
            "pending": "Pending",
            "reversal_due": "Refund recovery due",
            "reversed": "Reversed",
            "suspended": "Suspended",
            "trialing": "Trial",
            "uninstalled": "Uninstalled"
        },
        "empty": "Nothing to show yet.",
        "results": "{{total}} results",
        "page": "Page {{page}} of {{lastPage}}",
        "previous": "Previous page",
        "next": "Next page"
    },
    "PartnerNavigation": {
        "dashboard": "Overview",
        "retailers": "Retailers",
        "team": "Team",
        "installations": "Installations",
        "commissions": "Commissions",
        "settings": "Settings"
    },
    "CategoryMappings": {
        "title": "Category mapping",
        "description": "Review how categories from your feeds map to Google Product Taxonomy. AI suggestions are checked against our taxonomy; confirmed mappings are left unchanged.",
        "sourceFilter": "Filter source",
        "allSources": "All sources",
        "refresh": "Refresh",
        "total": "Total categories",
        "confirmed": "Confirmed",
        "review": "To map or review",
        "source": "Source",
        "external": "Category in your feed",
        "externalId": "External ID",
        "target": "Google Product Taxonomy",
        "searchTaxonomy": "Search by name, path, or GPT code",
        "status": "Status",
        "action": "Action",
        "save": "Save",
        "saving": "Saving…",
        "saved": "Category mapping saved.",
        "saveFailed": "Could not save this mapping.",
        "aiAction": "AI-map categories",
        "aiRunning": "AI mapping in progress…",
        "aiDone": "AI processed {{processed}} categories: {{confirmed}} confirmed, {{suggested}} suggested, {{needs_review}} need manual review.",
        "aiFailed": "AI mapping failed. Please try again.",
        "loadFailed": "Could not load category mappings.",
        "empty": "There are no feed categories to map yet.",
        "status_confirmed": "Confirmed",
        "status_suggested": "Suggested",
        "status_needs_review": "Needs review",
        "status_pending": "Pending"
    },
    "Navigation": {
        "discoveryStats": "View statistics",
        "catalogSources": "Catalog sources",
        "categoryMappings": "Category mapping",
        "plan": "My plan",
        "partnerReferral": "Referral partner",
        "delivery": "Delivery",
        "bestOffers": "Best offers",
        "billApprovals": "Bill Approvals",
        "campaigns": "Campaigns",
        "crossSellEarnings": "Cross Selling Earnings",
        "customers": "Customers",
        "dashboard": "Dashboard",
        "discounts": "Discounts",
        "distributors": "Distributors",
        "imports": "Imports",
        "items": "Items",
        "logout": "Logout",
        "pos_integration": "Store integrations",
        "products": "Products",
        "profile": "Profile",
        "repairServices": "Authorized Services",
        "scannedBills": "Scanned Bills",
        "settings": "Settings",
        "transactions": "Transactions",
        "users": "Users",
        "venues": "Venues",
        "warranties": "Warranties",
        "warranties_templates": "Warranty Templates"
    },
    "Next": "Next",
    "OrgUsers": {
        "addStaff": "Add Staff",
        "columns": {
            "createdAt": "Created",
            "email": "Email",
            "name": "Name",
            "role": "Role"
        },
        "createError": "Create Error",
        "createSuccess": "Create Success",
        "deleteConfirm": "Delete Confirm",
        "deleteError": "Delete Error",
        "deleteSuccess": "Delete Success",
        "editStaff": "Edit Staff",
        "email": "Email",
        "emailPlaceholder": "Enter email",
        "firstName": "First Name",
        "firstNamePlaceholder": "Enter first name",
        "lastName": "Last Name",
        "lastNamePlaceholder": "Enter last name",
        "leaveBlank": "Leave Blank",
        "password": "Password",
        "passwordPlaceholder": "Enter password",
        "passwordPlaceholderEdit": "Password Placeholder Edit",
        "passwordRequired": "Password Required",
        "requiredFields": "Required Fields",
        "role": "Role",
        "selectRole": "Select a role",
        "tabs": {
            "roles": "Roles & Permissions",
            "staff": "Staff Members"
        },
        "title": "Users",
        "updateError": "Update Error",
        "updateSuccess": "Update Success"
    },
    "POSIntegration": {
        "apiDescription": "API for integrating POS systems with our application.",
        "apiKeyGenerated": "API Key generated",
        "apiTitle": "POS Integration API",
        "generateApiKeySummary": "Generate API Key",
        "importItemsSummary": "Import Items",
        "itemsImportedSuccessfully": "Items imported successfully",
        "pageTitle": "POS Integration"
    },
    "PhoneInput": {
        "placeholder": "Enter Phone Number",
        "selectCountryCode": "Country Code"
    },
    "ProductApprovalDetail": {
        "actions": {
            "approve": {
                "button": "Approve & Add to Catalog",
                "description": "Add this product to your official catalog. It will become available for warranty tracking.",
                "title": "Approve Product"
            },
            "merge": {
                "confirmButton": "Confirm Merge",
                "description": "Link this virtual product to an existing product in your catalog.",
                "searchButton": "Search Products",
                "searchPlaceholder": "Search by name or model...",
                "title": "Merge with Existing"
            },
            "reject": {
                "button": "Reject Product",
                "description": "This product will not be added to your catalog.",
                "title": "Reject Product"
            }
        },
        "alreadyApproved": "This product has been approved",
        "alreadyMerged": "This product has been merged",
        "alreadyRejected": "This product has been rejected",
        "approveSuccess": "Product approved and added to your catalog.",
        "back": "Back to approvals",
        "error": "Failed to load product.",
        "fields": {
            "brand": "Brand",
            "category": "Category",
            "model": "Model",
            "parentCategory": "Parent Category",
            "source": "Source",
            "submittedAt": "Submitted"
        },
        "loading": "Loading product...",
        "mergeSuccess": "Product merged successfully.",
        "mergedInto": "Merged into",
        "notFound": "Product not found.",
        "notesPlaceholder": "Add any notes about this review...",
        "processing": "Processing...",
        "rejectModal": {
            "cancel": "Cancel",
            "confirm": "Confirm Rejection",
            "description": "Please select a reason for rejecting this product.",
            "reasons": {
                "counterfeit": "Suspected counterfeit",
                "discontinued": "Discontinued product",
                "duplicate": "Duplicate entry",
                "incorrectInfo": "Incorrect information",
                "notOurProduct": "Not our product",
                "other": "Other reason"
            },
            "selectReason": "Select a reason...",
            "title": "Reject Product"
        },
        "rejectSuccess": "Product rejected.",
        "reviewedAt": "Reviewed at",
        "sections": {
            "actions": "Actions",
            "category": "Category",
            "description": "Description",
            "extractedData": "Extracted Data",
            "identifiers": "Product Identifiers",
            "productInfo": "Product Information",
            "reviewNotes": "Review Notes",
            "sourceInfo": "Source Information"
        },
        "source": {
            "scannedBill": "Scanned Bill"
        },
        "title": "Product Review",
        "viewMergedProduct": "View merged product",
        "virtualProduct": "Virtual Product"
    },
    "ProductApprovals": {
        "actions": {
            "review": "Review"
        },
        "columns": {
            "actions": "Actions",
            "category": "Category",
            "identifiers": "Identifiers",
            "image": "Image",
            "productName": "Product",
            "source": "Source",
            "status": "Status",
            "submittedAt": "Submitted"
        },
        "empty": {
            "description": "Virtual products from scanned bills will appear here for your approval.",
            "title": "No products to review"
        },
        "error": "Failed to load products.",
        "filters": {
            "all": "All",
            "status": "Status"
        },
        "loading": "Loading products...",
        "searchPlaceholder": "Search by product name, EAN, or model...",
        "source": {
            "scannedBill": "Scanned Bill"
        },
        "stats": {
            "approved": "Approved",
            "merged": "Merged",
            "pending": "Pending",
            "rejected": "Rejected"
        },
        "status": {
            "approved": "Approved",
            "merged": "Merged",
            "pending": "Pending",
            "rejected": "Rejected"
        },
        "subtitle": "Review virtual products submitted from scanned bills and approve them for your catalog.",
        "title": "Product Approvals"
    },
    "Products": {
        "Overview": {
            "actions": "Actions",
            "availability": "Availability",
            "available": "Available",
            "category": "Category",
            "manufacturer": "Manufacturer",
            "price": "Price",
            "product_name": "Product name",
            "sku": "SKU",
            "source": "Source",
            "stock": "Stock",
            "title": "Catalog products",
            "unavailable": "Unavailable"
        },
        "SearchFilters": {
            "search_button": "Search",
            "search_placeholder": "Search by SKU, product, or manufacturer",
            "select_category": "Select category",
            "select_manufacturer": "Select manufacturer"
        },
        "overview": "Overview",
        "performance_insights": "Performance Insights",
        "title": "Products"
    },
    "Profile": {
        "address": "Address",
        "city": "City",
        "country": "Country",
        "dateOfBirth": "Date of birth",
        "email": "Email",
        "female": "Female",
        "gender": "Gender",
        "male": "Male",
        "name": "Name",
        "phone": "Phone",
        "save": "Save",
        "saveError": "Save Error",
        "saveSuccess": "Save Success",
        "saving": "Saving...",
        "selectCountry": "Select country",
        "selectGender": "Select gender",
        "surname": "Surname",
        "title": "Profile"
    },
    "Promotion Wizard": "Promotion Wizard",
    "Promotions Management": "Promotions Management",
    "QuestionModal": {
        "cancel": "Cancel",
        "email": "Email",
        "emailPlaceholder": "Enter your Email",
        "errors": {
            "emailRequired": "Email Required",
            "generic": "Please fix the errors below.",
            "nameRequired": "Name Required",
            "questionRequired": "Question is required.",
            "submitFailed": "Submit Failed"
        },
        "explanation": "Please fill in the information below.",
        "name": "Name/Company Name",
        "namePlaceholder": "Enter your Name or Company Name",
        "question": "Question",
        "questionPlaceholder": "Enter your Question here",
        "save": "Submit",
        "saving": "Submitting...",
        "title": "Submit Your Question"
    },
    "RegisterPage": {
        "admin_email": "Admin Email",
        "admin_name": "Admin Name",
        "admin_surname": "Admin Surname",
        "back_to_login": "Back to login",
        "company_name": "Company Name",
        "company_type": "Company Type",
        "check_email_title": "Check your email",
        "check_email_message": "We sent a verification link to {{email}}. Open it to activate your company account.",
        "verification_pending": "Waiting for email confirmation. This page checks automatically every 20 seconds.",
        "verification_checking": "Checking email confirmation…",
        "verification_approved": "Email confirmed and your retailer account is active. You can continue to sign in.",
        "verification_review": "Email confirmed. Your account is waiting for DigiWarranty review.",
        "verification_rejected": "Email confirmed, but the account needs assistance. Please contact DigiWarranty support.",
        "verification_expired": "This connection has expired. Start the store connection again.",
        "verification_unavailable": "We could not find this registration. Please contact DigiWarranty support.",
        "currency": "Currency",
        "password": "Password",
        "password_repeat": "Repeat Password",
                "field_required": "This field is required.",
        "fix_required": "Please fill all required fields.",
        "passwords_mismatch": "Passwords do not match.",
        "plugin_return_hint": "After verification, sign in and you will return to the {{platform}} connection.",
        "woocommerce_signup_note": "Create your retailer account on the Free plan. You can review upgrade options later in your dashboard. Email verification and account review may be required before you can create a store key.",
        "plan": "Choose a retailer plan",
        "mostPopular": "Most popular",
        "contactForPrice": "On request",
        "month": "month",
        "planFeatures": {
            "products": "{{count}} products",
            "unlimitedProducts": "Unlimited products",
            "venues": "{{count}} venues",
            "unlimitedVenues": "Unlimited venues",
            "syncs": "{{count}} catalogue syncs per day",
            "unlimitedSyncs": "Unlimited catalogue syncs",
            "reach": "{{count}} shoppers reached per month",
            "unlimitedReach": "Unlimited monthly reach",
            "loyaltyMembers": "{{count}} loyalty members",
            "unlimitedLoyaltyMembers": "Unlimited loyalty members",
            "analytics": "{{level}} analytics",
            "segmentation": "{{level}} customer segmentation",
            "api": "{{level}} API access",
            "loyalty": "Loyalty programme",
            "campaigns": "Campaigns",
            "push": "Push notifications",
            "email": "Email notifications",
            "prioritySupport": "Priority support"
        },
        "plan_required": "Select a retailer plan and try again. If no plans are available, refresh the page.",
        "registration_failed": "Registration failed. Please check the form and try again.",
        "registering": "Registering...",
        "select_currency": "Select currency",
        "select_required": "Please select company type and currency.",
        "select_type": "Select type",
        "submit": "Register",
        "subtitle": "Create your company account in minutes.",
        "title": "Register Company"
    },
    "Requirement": "Requirement",
    "RetailerBestOffers": {
        "distributor": "Distributor",
        "distributorFilter": "Distributor",
        "empty": "No active distributor discounts right now. Check back soon!",
        "error": "Unable to load best offers.",
        "manufacturer": "Manufacturer",
        "manufacturerFilter": "Manufacturer",
        "minDiscount": "Min %",
        "noDescription": "No description provided.",
        "off": "off",
        "results": "results",
        "searchPlaceholder": "Search products, manufacturers...",
        "sortBy": "Sort by",
        "sortDate": "End Date",
        "sortDiscount": "Discount",
        "sortName": "Name",
        "subtitle": "Discover the best discounts from your distributors",
        "title": "Best Offers",
        "validPeriod": "Valid Period",
        "validUntil": "Valid until {{end}}",
        "youSave": "You save"
    },
    "RetailerDiscounts": {
        "empty": "No discounts recorded yet.",
        "error": "Unable to load discounts.",
        "filterLabel": "Filter discounts by status",
        "filters": {
            "all": "All"
        },
        "manageCatalog": "Manage catalog",
        "resultsCount": "Total discounts: {{count}}",
        "status": {
            "active": "Active",
            "expired": "Expired",
            "upcoming": "Upcoming"
        },
        "subtitle": "Track upcoming promotions, live offers, and completed discounts in one place.",
        "summary": {
            "active": "Active",
            "expired": "Expired",
            "upcoming": "Upcoming"
        },
        "tableTitle": "Discount overview",
        "table": {
            "clicks": "Clicks",
            "discount": "Discount",
            "end": "Valid until",
            "global": "All venues",
            "product": "Product",
            "shows": "Shows",
            "status": "Status",
            "venue": "Venue",
            "views": "Views"
        },
        "title": "Your discounts"
    },
    "RetailerDistributorDetail": {
        "activeDiscounts": "Active Discounts",
        "backToList": "Back to Distributors",
        "categories": "Categories",
        "categoriesList": "Categories",
        "description": "Description",
        "discountsTab": "Discounts",
        "distributorLabel": "Distributor",
        "email": "Email",
        "error": "Unable to load distributor details.",
        "infoTab": "Info",
        "manufacturer": "Manufacturer",
        "manufacturers": "Manufacturers",
        "manufacturersTab": "Manufacturers",
        "name": "Name",
        "noDiscounts": "No active discounts from this distributor.",
        "noManufacturers": "No manufacturers listed.",
        "off": "off",
        "searchDiscounts": "Search discounts...",
        "validPeriod": "Valid Period",
        "website": "Website",
        "youSave": "You save"
    },
    "RetailerDistributors": {
        "availableInfo": "Contact distributors to establish a business connection.",
        "empty": "No distributors connected yet.",
        "emptyAvailable": "No available distributors found.",
        "error": "Unable to load distributors.",
        "errorAvailable": "Unable to load available distributors.",
        "findNew": "Find New Distributors",
        "myDistributors": "My Distributors",
        "searchAvailablePlaceholder": "Search for new distributors...",
        "searchPlaceholder": "Search distributors...",
        "stats": {
            "activeDiscounts": "Active Discounts",
            "categories": "Categories Covered",
            "connected": "Connected Distributors"
        },
        "subtitle": "Manage your distributor connections",
        "table": {
            "categories": "Categories",
            "description": "Description",
            "discounts": "Active Discounts",
            "manufacturers": "Manufacturers",
            "name": "Name",
            "view": "View"
        },
        "title": "Distributors"
    },
    "Save Campaign": "Save Campaign",
    "ScannedBills": {
        "statuses": {
            "admin_review": "Awaiting admin review",
            "needs_review": "Needs review",
            "org_review": "Awaiting organization",
            "pending_retailer": "Awaiting retailer",
            "pending_upload": "Awaiting upload",
            "processed": "Approved",
            "recognized": "Read by AI",
            "rejected": "Rejected",
            "retailer_approved": "Approved by retailer",
            "retailer_rejected": "Rejected by retailer",
            "user_confirmed": "Confirmed by user"
        },
        "adminTitle": "Scanned Bills",
        "bulkAction": "Apply status",
        "columns": {
            "actions": "Actions",
            "createdAt": "Created",
            "organization": "Organization",
            "status": "Status",
            "total": "Total",
            "user": "User"
        },
        "detailTitle": "Scan Details",
        "error": "Failed to load scans.",
        "filters": {
            "all": "All",
            "status": "Status"
        },
        "itemsTitle": "Items",
        "loading": "Loading scans...",
        "matchManufacturerItem": "Manufacturer item ID",
        "matchOrganization": "Organization ID",
        "matchVariant": "Variant ID",
        "matchVenue": "Venue ID",
        "orgTitle": "Scanned Bills",
        "previewImages": "Images",
        "reprocess": "Reprocess OCR",
        "review": "Review",
        "reviewNotes": "Add review notes",
        "saveReview": "Save review",
        "stats": {
            "needsReview": "Needs review",
            "pending": "Pending",
            "processed": "Processed",
            "rejected": "Rejected",
            "total": "Total scans"
        },
        "view": "View"
    },
    "Settings": {
        "Delivery": {
            "tab": "Delivery",
            "title": "Where you deliver",
            "subtitle": "Your discounts are shown to users in the countries you deliver to. Until you change this, only users in your own country see them.",
            "scopes": {
                        "domestic": "Only my country",
                        "domesticNamed": "Only {{country}}",
                        "countries": "Selected countries",
                        "worldwide": "Everywhere"
            },
            "scopeHints": {
                        "domestic": "Your offers stay visible at home only.",
                        "countries": "Pick the countries you post to.",
                        "worldwide": "Anyone, anywhere, sees your offers."
            },
            "quickGroups": "Quick add:",
            "groups": {
                        "exYu": "Ex-Yu",
                        "eu": "EU",
                        "eea": "EEA"
            },
            "continents": {
                        "Europe": "Europe",
                        "Asia": "Asia",
                        "Africa": "Africa",
                        "Americas": "Americas",
                        "Oceania": "Oceania",
                        "Antarctic": "Antarctic",
                        "Other": "Other"
            },
            "searchPlaceholder": "Search a country…",
            "noMatches": "No country matches “{{term}}”.",
            "clearAll": "Clear all",
            "homeCountry": "Home",
            "disclaimer": "This is your own statement about where you post, and it decides who sees your offers. Adding a country you do not actually ship to means customers there will see prices they cannot buy at.",
            "pickAtLeastOne": "Choose at least one country, or pick a different delivery option.",
            "save": "Save",
            "saving": "Saving…",
            "saved": "Delivery settings saved.",
            "saveFailed": "Delivery settings could not be saved.",
            "loadFailed": "Delivery settings could not be loaded."
        },
        "Billing": {
            "Tutorial": {
                "explanation_message": "View and manage your organization’s payment methods, auto-payment settings, monthly bills, and invoices.",
                "explanation_title": "Manage Billing",
                "title": "Billing Settings Tutorial"
            },
            "amount": "Amount",
            "autoPayment": "Auto-Payment",
            "autoPaymentError": "Failed to update auto-payment setting",
            "autoPaymentSuccess": "Auto-payment setting updated successfully!",
            "billingEmail": "Billing Email",
            "billingEmailError": "Failed to save billing email",
            "billingEmailPlaceholder": "Enter billing email",
            "billingEmailSaved": "Billing email saved.",
            "cardError": "Failed to save card",
            "cardSaved": "Card saved successfully.",
            "currentPaymentMethod": "Current Payment Method",
            "download": "Download",
            "enableAutoPayment": "Enable Auto-Payment",
            "enterCard": "Add a card to enable billing.",
            "error": "Error loading billing data",
            "invoiceNumber": "Invoice Number",
            "invoices": "Invoices",
            "issuedDate": "Issued Date",
            "loadingPaymentForm": "Loading payment form...",
            "missingPublishableKey": "Stripe publishable key is missing.",
            "monthlyBills": "Monthly Bills",
            "noBills": "No bills available.",
            "noInvoices": "No invoices available.",
            "noPaymentMethod": "No payment method on file (Stripe integration pending)",
            "paymentMethod": "Payment Method",
            "period": "Period",
            "saveBillingEmail": "Save Billing Email",
            "saveCard": "Save Card",
            "savingCard": "Saving...",
            "setupIntentError": "Unable to start card setup",
            "status": "Status",
            "title": "Billing Settings",
            "updatePaymentMethod": "Update Payment Method"
        },
        "Contracts": {
            "Tutorial": {
                "explanation_message": "Set up financial terms for your organization, including transaction fees, notification fees, subscription fees, and cross-sell commissions, and view contract history.",
                "explanation_title": "Configure Contracts",
                "title": "Contracts Settings Tutorial"
            },
            "active": "Active",
            "contractActive": "Contract Active",
            "contractHistory": "Contract History",
            "contractTerms": "Contract Terms",
            "crossSellCommission": "Cross-Sell Commission (%)",
            "crossSellCommissionPlaceholder": "e.g., 10.00",
            "emailNotificationFee": "Email Notification Fee ($)",
            "emailNotificationFeePlaceholder": "e.g., 0.05",
            "endDate": "End Date",
            "error": "Error loading contracts",
            "fixedTransactionFee": "Fixed Transaction Fee ($)",
            "fixedTransactionFeePlaceholder": "e.g., 1.00",
            "inactive": "Inactive",
            "monthlySubscriptionFee": "Monthly Subscription Fee ($)",
            "monthlySubscriptionFeePlaceholder": "e.g., 100.00",
            "noContracts": "No contracts available.",
            "nonNegative": "Must be non-negative",
            "ongoing": "Ongoing",
            "profitPercentageFee": "Transaction Fee (%)",
            "profitPercentageFeePlaceholder": "e.g., 2.00",
            "promosFeePerDay": "Promos Fee Per Day ($)",
            "promosFeePerDayPlaceholder": "e.g., 1.50",
            "pushNotificationFee": "Push Notification Fee ($)",
            "pushNotificationFeePlaceholder": "e.g., 0.03",
            "question": "Help",
            "saveContract": "Save Contract",
            "saveError": "Failed to save contract",
            "saveSuccess": "Contract saved successfully!",
            "shareInitialPrice": "Share Initial Price",
            "smsNotificationFee": "SMS Notification Fee ($)",
            "smsNotificationFeePlaceholder": "e.g., 0.10",
            "startDate": "Start Date",
            "startDateRequired": "Start date is required",
            "status": "Status",
            "title": "Contracts Settings",
            "tutorial": "Tutorial"
        },
        "General": {
            "Tutorial": {
                "explanation_message": "Set up your organization’s basic information, localization preferences, integration endpoints, and notification settings.",
                "explanation_title": "Configure General Settings",
                "title": "General Settings Tutorial"
            },
            "address": "Address",
            "addressPlaceholder": "Enter address",
            "basicInfo": "Basic Information",
            "country": "Country",
            "currency": "Currency",
            "defaultItemApiEndpoint": "Default Item API Endpoint",
            "defaultItemApiEndpointPlaceholder": "e.g., https://api.organization.com/items",
            "defaultItemEndpoint": "Default Item Endpoint",
            "defaultItemEndpointPlaceholder": "e.g., https://www.organization.com/",
            "defaultUserParameter": "Default User Parameter",
            "defaultUserParameterPlaceholder": "e.g., user_id",
            "description": "Description",
            "descriptionPlaceholder": "Enter description",
            "email": "Company Email",
            "emailPlaceholder": "Enter company email",
            "error": "Error loading general settings",
            "foundedDate": "Founded Date",
            "integrationEndpoints": "Integration Endpoints",
            "invalidEmail": "Invalid email address",
            "invalidNotificationPreferences": "Invalid notification preferences format",
            "invalidUrl": "Must be a valid URL",
            "language": "Language",
            "localization": "Localization",
            "logo": "Logo",
            "logoHint": "Upload a square logo (e.g. 256x256 or 512x512) for best results.",
            "logoPreview": "Logo preview",
            "logoUploadCta": "Change logo",
            "logoUploadError": "Logo upload failed.",
            "logoUploaded": "Logo uploaded.",
            "logoUploading": "Uploading logo...",
            "name": "Organization Name",
            "namePlaceholder": "Enter organization name",
            "nameRequired": "Organization name is required",
            "notificationEmail": "Notification Email",
            "notificationEmailPlaceholder": "Enter notification email",
            "notificationPreferences": "Notification Preferences",
            "notificationPreferencesPlaceholder": "Enter JSON preferences",
            "notifications": "Notifications",
            "orgType": "Organization Type",
            "phone": "Phone",
            "phoneCountry": "Phone Country",
            "phonePlaceholder": "Enter phone number",
            "taxId": "Tax ID",
            "taxIdPlaceholder": "Enter the company tax ID",
            "taxIdPending": "You can add this later. A changed number requires verification.",
            "taxIdVerified": "Verified tax ID",
            "vatId": "VAT ID",
            "vatIdPlaceholder": "Enter VAT ID, if applicable",
            "question": "Help",
            "saveBasicInfo": "Update Basic information",
            "saveBasicInfoError": "Failed to save basic information",
            "saveBasicInfoSuccess": "Basic information saved successfully!",
            "saveChanges": "Save Changes",
            "saveError": "Failed to save settings",
            "saveIntegrationEndpoints": "Update Integration Settings",
            "saveIntegrationEndpointsError": "Failed to save integration endpoints",
            "saveIntegrationEndpointsSuccess": "Integration endpoints saved successfully!",
            "saveLocalization": "Save Localization settings",
            "saveLocalizationError": "Failed to save localization settings",
            "saveLocalizationSuccess": "Localization settings saved successfully!",
            "saveNotifications": "Update Notifications Settings",
            "saveNotificationsError": "Failed to save notification settings",
            "saveNotificationsSuccess": "Notification settings saved successfully!",
            "saveSuccess": "Settings saved successfully!",
            "selectCountry": "Select Country",
            "selectCurrency": "Select Currency",
            "selectLanguage": "Select Language",
            "selectTimezone": "Select Timezone",
            "selectType": "Select Type",
            "sendEmailNotifications": "Send Notifications via Email",
            "sendPushNotifications": "Send Notifications via Push",
            "sendSmsNotifications": "Send Notifications via SMS",
            "timezone": "Timezone",
            "title": "General Settings",
            "tutorial": "Tutorial",
            "uploadLogo": "Upload Logo",
            "website": "Website",
            "websitePlaceholder": "Enter website"
        },
        "Integrations": {
            "Tutorial": {
                "explanation_message": "Add and manage POS or website integrations, and view CSV upload history for inventory management.",
                "explanation_title": "Manage Integrations",
                "title": "Integrations Settings Tutorial"
            },
            "actions": "Actions",
            "activate": "Activate",
            "active": "Active",
            "addIntegration": "Add Integration",
            "apiEndpoint": "API Endpoint",
            "apiEndpointPlaceholder": "Enter API endpoint",
            "csvUploadHistory": "CSV Upload History",
            "currentIntegrations": "Current Integrations",
            "daily": "Daily",
            "deactivate": "Deactivate",
            "delete": "Delete Integration",
            "deleteConfirm": "Delete Confirm",
            "deleteError": "Delete Error",
            "deleteSuccess": "Delete Success",
            "deleteTitle": "Delete Title",
            "email": "Email",
            "emailPlaceholder": "Enter contact email",
            "endpoint": "Endpoint",
            "error": "Error loading integrations",
            "errors": "Errors",
            "fileName": "File Name",
            "general": "General",
            "hasErrors": "Has Errors",
            "hourly": "Hourly",
            "inactive": "Inactive",
            "invalidEmail": "Invalid email address",
            "invalidUrl": "Must be a valid URL",
            "name": "Name",
            "namePlaceholder": "e.g., Square POS, Shopify",
            "nameRequired": "Name is required",
            "noCsvUploads": "No uploads yet",
            "noErrors": "No errors",
            "noIntegrations": "No integrations configured.",
            "pos": "POS Integrations",
            "processedAt": "Processed At",
            "realtime": "Realtime",
            "saveError": "Failed to save integration",
            "saveSuccess": "Integration saved successfully!",
            "status": "Status",
            "statusError": "Failed to update integration status",
            "statusSuccess": "Integration status updated successfully!",
            "syncInterval": "Sync Interval",
            "title": "Integrations",
            "venueId": "Venue ID (Optional)",
            "venueIdPlaceholder": "Enter venue ID",
            "apiKey": "API Key",
            "noLogs": "No integration logs found.",
            "copiedToClipboard": "Copied to clipboard",
            "retailer": {
                "title": "Connected store plugins",
                "subtitle": "Review each store connection and its latest synchronization activity.",
                "tab": "Store plugins",
                "refresh": "Refresh connections",
                "summary": "Connection summary",
                "total": "Stores",
                "active": "Active",
                "errors": "With errors",
                "filter": "Filter connections",
                "filters": { "all": "All", "woocommerce": "WooCommerce", "shopware": "Shopware", "shopify": "Shopify" },
                "loading": "Loading store connections...",
                "loadError": "Could not load store connections.",
                "retry": "Retry",
                "empty": "No store plugins are connected to this organization.",
                "emptyFilter": "No connections for this platform.",
                "store": "Store",
                "connection": "Connection",
                "features": "Enabled data",
                "frequency": "Schedule",
                "lastActivity": "Last activity",
                "lastError": "Latest error",
                "products": "Products",
                "discounts": "Discounts",
                "checkout": "Checkout",
                "manual": "Manual",
                "seen": "Connected",
                "never": "Never",
                "none": "None",
                "status": { "active": "Active", "inactive": "Inactive", "disconnected": "Disconnected", "pending": "Pending" },
                "createWooKey": "Create WooCommerce key",
                "createPlatformKey": "Create integration key",
                "platform": "Platform",
                "keyCreateHint": "This key is for one {{platform}} installation. It becomes bound to its store and sales channel when the plugin validates it.",
                "connectionName": "Connection name",
                "venue": "Online venue",
                "createKey": "Generate credentials",
                "creatingKey": "Generating...",
                "keyCreated": "Credentials created",
                "copyNow": "Copy both values now. The API secret is shown only once.",
                "apiKey": "API key",
                "apiSecret": "API secret",
                "copyKey": "Copy API key",
                "copySecret": "Copy API secret",
                "keyCreateError": "Could not create integration credentials. Check organization-admin access and retry.",
                "copyError": "Could not copy the credential. Select and copy it manually.",
                "awaitingValidation": "Waiting for plugin validation",
                "actions": "Actions",
                "revoke": "Revoke",
                "confirmRevoke": "Revoke this unused integration key? It will no longer connect any store.",
                "revokeError": "Could not revoke the pending integration key.",
                "noVenues": "Create an online venue before generating store credentials.",
                "loadingVenues": "Loading online venues..."
            }
        },
        "Points": {
            "Tutorial": {
                "explanation_message": "Set up your organization’s loyalty points system, including points earning rates for regular and cross-sell purchases, maximum points per transaction, and redemption settings.",
                "explanation_title": "Configure Loyalty Points",
                "title": "Points Settings Tutorial"
            },
            "error": "Error loading points settings",
            "loyaltyPoints": "Loyalty Points Configuration",
            "maxPointsPerTransaction": "Max Points per Transaction",
            "maxPointsPerTransactionPlaceholder": "e.g., 100.00",
            "nonNegative": "Must be non-negative",
            "pointsPerCrossSellUnit": "Points per Cross-Sell Unit",
            "pointsPerCrossSellUnitPlaceholder": "e.g., 0.1000",
            "pointsPerCurrencyUnit": "Points per Currency Unit",
            "pointsPerCurrencyUnitPlaceholder": "e.g., 1.0000",
            "question": "Help",
            "redemptionRate": "Redemption Rate",
            "redemptionRatePlaceholder": "e.g., 0.0100",
            "saveError": "Failed to save points settings",
            "savePointsSettings": "Save Points Settings",
            "saveSuccess": "Points settings saved successfully!",
            "title": "Points Settings",
            "tutorial": "Tutorial"
        },
        "RepairServices": {
            "Tutorial": {
                "explanation_message": "Search for service providers by brand and category to find suitable partners for your needs.",
                "explanation_title": "How to Use Authorized Services",
                "title": "Authorized Services Tutorial"
            },
            "address": "Address",
            "brandRequired": "Brand is required",
            "categoryRequired": "Category is required",
            "error": "Error",
            "noRepairCompanies": "No service providers found",
            "phone": "Phone",
            "question": "Ask a Question",
            "search": "Search for Service Providers",
            "selectBrand": "Select Brand",
            "selectCategory": "Select Category",
            "serviceProvider": "Service Provider",
            "title": "Authorized Services",
            "tutorial": "View Tutorial",
            "venueName": "Venue Name"
        },
        "Security": {
            "generate": "Generate",
            "length": "Password length",
            "lengthOption": "{{count}} characters",
            "entropyHint": "{{bits}} bits of entropy",
            "copy": "Copy",
            "copied": "Password copied.",
            "copyFailed": "Could not copy. Select the field and copy manually.",
            "nothingToCopy": "Nothing to copy yet.",
            "reveal": "Show password",
            "hide": "Hide password",
            "generatedAndCopied": "Password generated and copied.",
            "generatedNotCopied": "Password generated. Copying failed, please copy it manually.",
            "saveItSomewhere": "Save the password before you confirm — we cannot show it again afterwards.",
            "Tutorial": {
                "explanation_message": "Manage your user password and recovery email, and configure your organization’s API settings.",
                "explanation_title": "Secure Your Account",
                "title": "Security Settings Tutorial"
            },
            "apiActive": "API Active",
            "apiKey": "API Key",
            "apiKeyError": "Failed to regenerate API key",
            "apiKeySuccess": "API key regenerated successfully!",
            "apiStatusError": "Failed to update API status",
            "apiStatusSuccess": "API status updated successfully!",
            "confirmPassword": "Confirm New Password",
            "confirmPasswordPlaceholder": "Confirm new password",
            "currentPassword": "Current Password",
            "currentPasswordPlaceholder": "Enter current password",
            "currentPasswordRequired": "Current password is required",
            "error": "Error loading security settings",
            "invalidEmail": "Invalid email address",
            "newPassword": "New Password",
            "newPasswordPlaceholder": "Enter new password",
            "noApiKey": "No API key generated",
            "noOrganization": "No organization data available",
            "organizationApi": "Organization API",
            "passwordMinLength": "Password must be at least 8 characters",
            "passwordsDoNotMatch": "Passwords do not match",
            "question": "Question",
            "recoveryEmail": "Recovery Email",
            "recoveryEmailPlaceholder": "Enter recovery email",
            "regenerateApiKey": "Regenerate API Key",
            "saveError": "Failed to update security settings",
            "saveSuccess": "Security settings updated successfully!",
            "title": "Security Settings",
            "tutorial": "Tutorial",
            "updateUserSecurity": "Update User Security",
            "userSecurity": "User Security"
        },
        "Tutorial": {
            "explanation_message": "Manage your organization’s settings, including general information, billing, security, integrations, contracts, and loyalty points.",
            "explanation_title": "Overview",
            "title": "Settings Tutorial"
        },
        "UserInfo": {
            "Tutorial": {
                "explanation_message": "Update your personal information and manage users within your organization.",
                "explanation_title": "Manage User Information",
                "title": "User Info Settings Tutorial"
            },
            "actions": "Actions",
            "addUser": "Add User",
            "country": "Country",
            "email": "Email",
            "emailPlaceholder": "Enter your email",
            "error": "Error loading user info",
            "invalidEmail": "Invalid email address",
            "name": "Name",
            "namePlaceholder": "Enter your name",
            "nameRequired": "Name is required",
            "noUsers": "No organization users available.",
            "organizationUsers": "Organization Users",
            "personalInfo": "Personal Information",
            "phoneNumber": "Phone Number",
            "phoneNumberPlaceholder": "Enter your phone number",
            "remove": "Remove",
            "role": "Role",
            "saveError": "Failed to update user info",
            "savePersonalInfo": "Save Personal Info",
            "saveSuccess": "User info updated successfully!",
            "selectCountry": "Select Country",
            "title": "User Info Settings"
        },
        "billing": "Billing",
        "contracts": "Contracts",
        "error": "Error loading settings data",
        "general": "General",
        "integrations": "Integrations",
        "loading": "Loading...",
        "noOrganization": "No organization data available.",
        "points": "Points Settings",
        "security": "Security",
        "title": "Settings",
        "userInfo": "User Info"
    },
    "Strategies": "Strategies",
    "Strategy Name": "Strategy Name",
    "Target Name": "Target Name",
    "Targets": "Targets",
    "Transactions": {
        "TransactionsOverview": {
            "columns": {
                "averagePrice": "Average Price",
                "averageRevenue": "Average Revenue",
                "date": "Date",
                "totalPrice": "Total Price",
                "totalRevenue": "Total Revenue",
                "transactionCount": "Transaction Count"
            },
            "distinctBuyers": "Distinct Buyers",
            "distinctManufacturers": "Distinct Manufacturers",
            "loading": "Loading transactions...",
            "noStatistics": "No transaction statistics available.",
            "questionMessage": "If you have any questions about the transactions or data displayed, please click the question mark icon to submit your question.",
            "questionTitle": "Have Questions?",
            "totalPrice": "Total Price",
            "totalRevenue": "Total Revenue",
            "totalTransactions": "Total Transactions"
        },
        "TransactionsProgress": {
            "ageGroups": "Age Groups",
            "cityDistribution": "City Distribution",
            "countryDistribution": "Country Distribution",
            "currentPeriod": "Current Period",
            "demographics": "Demographics",
            "distinctBuyerCount": "Distinct Buyer Count",
            "distinctManufacturers": "Distinct Manufacturers",
            "error": "Error fetching progress data: {{error}}",
            "genderDistribution": "Gender Distribution",
            "loading": "Loading...",
            "previousPeriod": "Previous Period",
            "residentialCountryDistribution": "Residential Country Distribution",
            "showingDataFor": "Showing data for: {{period}}",
            "title": "Transactions Progress",
            "totalPrice": "Total Price",
            "totalRevenue": "Total Revenue",
            "totalTransactions": "Total Transactions",
            "totals": "Totals"
        },
        "TransactionsStatistics": {
            "ageGroupDistribution": "Age Group Distribution",
            "cityDistribution": "City Distribution",
            "countryDistribution": "Country Distribution",
            "error": "Error loading demographics data: {{error}}",
            "genderDistribution": "Gender Distribution",
            "loading": "Loading demographics data...",
            "questionMessage": "If you have any questions about the demographics or data displayed, please click the question mark icon to submit your question.",
            "questionTitle": "Have Questions?",
            "residentialCountryDistribution": "Residential Country Distribution",
            "title": "Transactions Demographics"
        },
        "Tutorial": {
            "customization_message": "All these features can be customized and enriched even more with upcoming features such as filtering and targeting.",
            "customization_title": "Customization",
            "overview_tab_message": "The first Overview tab shows the transactions grouped by date and summarizes that period in the headers.",
            "overview_tab_title": "Overview Tab",
            "period_selection_message": "You can choose the period for the details shown in the right corner of the page. The selected period is shared across each tab you select.",
            "period_selection_title": "Period Selection",
            "progress_tab_message": "The third tab shows a comparison of the selected period. For instance, if 'Yesterday' is selected, it compares data with the day before yesterday. If 'Last Week' is selected, it compares data with the previous week, and similarly for 'This Month,' 'This Quarter,' and 'This Year.'",
            "progress_tab_title": "Progress Tab",
            "statistics_tab_message": "The second tab shows user demographics and interactions with the organization, such as genders, countries where items were purchased, the countries where users are from, age groups of users, and cities.",
            "statistics_tab_title": "Statistics Tab",
            "title": "Transactions Tutorial",
            "welcome_message": "Welcome to the Transactions tutorial! Here’s what you need to know."
        },
        "loading": "Loading transactions...",
        "noTransactions": "No transactions available.",
        "overview": "Overview",
        "progress": "Progress",
        "statistics": "Statistics",
        "title": "Transactions"
    },
    "Type": "Type",
    "Update": "Update",
    "UserInfoModal": {
        "cancel": "Cancel",
        "email": "Email",
        "emailPlaceholder": "Enter your Email",
        "errors": {
            "emailRequired": "Email is required.",
            "generic": "Please fix the errors below.",
            "nameRequired": "Name is required."
        },
        "explanation": "Please enter your Name/Company Name and Email. Your email will only be used to respond to any questions you may have about the system during your demo.",
        "explanationSub": "You can leave this fields empty if you do not have any questions at this time.",
        "name": "Name/Company Name",
        "namePlaceholder": "Enter your Name or Company Name",
        "save": "Save",
        "title": "Enter Your Information"
    },
    "Users": {
        "Roles": {
            "addRole": "Add Role",
            "cannotDeleteSystem": "Cannot Delete System",
            "cannotDeleteWithUsers": "Cannot Delete With Users",
            "columns": {
                "name": "Name",
                "permissions": "Permissions",
                "type": "Type",
                "users": "Users"
            },
            "createError": "Create Error",
            "createRole": "Create Role",
            "createSuccess": "Create Success",
            "customRole": "Custom Role",
            "deleteConfirm": "Delete Confirm",
            "deleteError": "Delete Error",
            "deleteSuccess": "Delete Success",
            "description": "Description",
            "descriptionPlaceholder": "Description Placeholder",
            "editRole": "Edit Role",
            "loadError": "Load Error",
            "module": "Module",
            "modules": {
                "campaigns": "Campaigns",
                "customers": "Customers",
                "discounts": "Discounts",
                "integrations": "Integrations",
                "items": "Items",
                "products": "Products",
                "roles": "Roles",
                "settings": "Settings",
                "transactions": "Transactions",
                "users": "Users",
                "venues": "Venues",
                "warranties": "Warranties"
            },
            "nameRequired": "Name Required",
            "noRoles": "No Roles",
            "noRolesDescription": "No Roles Description",
            "permissions": {
                "delete": "Delete",
                "none": "None",
                "read": "Read",
                "write": "Write"
            },
            "permissionsTitle": "Permissions Title",
            "roleName": "Role Name",
            "roleNamePlaceholder": "Role Name Placeholder",
            "systemRole": "System Role",
            "title": "Title",
            "updateError": "Update Error",
            "updateSuccess": "Update Success"
        },
        "Timeline": {
            "avgGrowth": "Avg Growth",
            "chartTitle": "Chart Title",
            "customers": "Customers",
            "error": "Error loading timeline data",
            "latestMonth": "Latest Month",
            "loading": "Loading timeline data...",
            "loadingChart": "Loading Chart",
            "newCustomers": "New Customers",
            "title": "Customer Registrations by Month",
            "totalCustomers": "Total Customers",
            "totalOverall": "Total Overall",
            "xAxisTitle": "Month",
            "yAxisTitle": "Number of Registrations"
        },
        "Tutorial": {
            "explanation_message": "There are two types of users within organizations: users registered through their own organization and users registered through other organizations. Due to stricter privacy rules in the full version, some fields will not be visible for users who do not belong to the organization. Statistical overviews can be customized according to the organization's needs, allowing them to choose which information they want to track.",
            "explanation_title": "Overview",
            "title": "Users Tutorial"
        },
        "UserCreate": {
            "cancel": "Cancel",
            "country": "Country",
            "createSuccess": "Create Success",
            "email": "Email",
            "emailPlaceholder": "Email Placeholder",
            "errorAlert": "Please fix the errors below.",
            "gender": "Gender",
            "loadError": "Load Error",
            "loading": "Loading",
            "name": "Name",
            "namePlaceholder": "Name Placeholder",
            "personalId": "Personal ID",
            "phoneNumber": "Phone Number",
            "save": "Save",
            "saveError": "Save Error",
            "saving": "Saving...",
            "selectCountry": "Select Country",
            "selectGender": "Select Gender",
            "surname": "Surname",
            "surnamePlaceholder": "Surname Placeholder",
            "title": "Add Customer",
            "update": "Update",
            "updateSuccess": "Update Success",
            "validationError": "Validation Error"
        },
        "UserStatistics": {
            "global": "Global",
            "items": "Items",
            "loadError": "Load Error",
            "loading": "Loading statistics...",
            "noData": "No Data",
            "noStatistics": "No statistics available.",
            "overviewTitle": "Statistics Overview",
            "own": "Own",
            "salesByCountry": {
                "title": "Sales by Countries",
                "userCount": "{{userCount}} users"
            },
            "topBuyersByItems": "Top Buyers by Items",
            "topBuyersByTotalSpent": "Top Buyers by Total Spent",
            "totalBuyers": "Total Buyers",
            "totalBuyersGlobal": "Total Buyers (Global)",
            "totalBuyersOwn": "Total Buyers (Own)",
            "totalRevenueGlobal": "Total Revenue (Global)",
            "totalRevenueOwn": "Total Revenue (Own)"
        },
        "UsersList": {
            "addUserButton": "Add Customer",
            "columns": {
                "countOfItems": "Count of Items",
                "firstTransactionDate": "First Transaction Date",
                "lastTransactionDate": "Last Transaction Date",
                "name": "Name",
                "status": "Status",
                "totalSpent": "Total Spent",
                "userId": "User ID",
                "venuesCount": "Venues Count"
            },
            "deleteConfirm": "Delete Confirm",
            "deleteError": "Delete Error",
            "deleteSuccess": "Delete Success",
            "deleteTitle": "Delete Title",
            "editModalTitle": "Edit Modal Title",
            "globalUser": "Global Customer",
            "legend": "Legend:",
            "loadError": "Load Error",
            "loading": "Loading...",
            "modalTitle": "Add Customer",
            "noCustomers": "No Customers",
            "noUsers": "No customers available.",
            "ownUser": "Own Customer",
            "searchPlaceholder": "Search Placeholder",
            "title": "Customers"
        },
        "statistics": "Statistics",
        "timeline": "Timeline",
        "title": "Customers",
        "usersList": "Customers List",
        "SalesByCountryCompare": {
            "noData": "No Data",
            "salesLabel": "Sales Label",
            "title": "Title",
            "usersLabel": "Users Label"
        }
    },
    "Value": "Value",
    "Venues": {
        "Tutorial": {
            "exploration_message": "Click on 'Edit' to see what additional information and metrics you can track for each venue.",
            "exploration_title": "Explore Venue Details",
            "title": "Venues Management Tutorial",
            "venues_management_message": "You can easily add, edit, or delete venues as needed.",
            "venues_management_title": "Manage Your Venues",
            "welcome_message": "Welcome to the Venues Management tutorial."
        },
        "VenueForm": {
            "address_label": "Address:",
            "address_placeholder": "Venue Address",
            "basic_info": "Basic Information",
            "city_label": "City:",
            "city_placeholder": "Venue City",
            "country_label": "Country:",
            "createSuccess": "Create Success",
            "description_label": "Description:",
            "description_placeholder": "Venue Description",
            "email_label": "Email:",
            "email_placeholder": "Venue Email",
            "errors": {
                "address_required": "Address is required",
                "city_required": "City is required",
                "country_required": "Country is required",
                "email_invalid": "Email is invalid",
                "email_required": "Email is required",
                "latitude_invalid": "Latitude must be a number",
                "latitude_range": "Latitude must be between -90 and 90",
                "longitude_invalid": "Longitude must be a number",
                "longitude_range": "Longitude must be between -180 and 180",
                "name_required": "Name is required",
                "phone_country_required": "Select phone country",
                "phone_required": "Phone is required",
                "website_invalid": "Enter a valid website (e.g. gsoft.hr)",
                "website_required": "Website is required"
            },
            "facebook_label": "Facebook:",
            "facebook_placeholder": "https://facebook.com/venue",
            "instagram_label": "Instagram:",
            "instagram_placeholder": "https://instagram.com/venue",
            "latitude_label": "Latitude:",
            "latitude_placeholder": "Latitude",
            "loadError": "Load Error",
            "loading": "Loading venue...",
            "location_details": "Location Details",
            "longitude_label": "Longitude:",
            "longitude_placeholder": "Longitude",
            "name_label": "Name:",
            "name_placeholder": "Venue Name",
            "phone_label": "Phone:",
            "saveError": "Save Error",
            "save_button": "Save",
            "select_country": "Select Country",
            "social_media": "Social Media Links",
            "title_create": "Create New Venue",
            "title_edit": "Edit Venue {{venueName}}",
            "twitter_label": "Twitter:",
            "twitter_placeholder": "https://twitter.com/venue",
            "updateSuccess": "Update Success",
            "validationError": "Validation Error",
            "website_label": "Website:",
            "website_placeholder": "Venue Website"
        },
        "VenueView": {
            "Tutorial": {
                "details_message": "This tab provides an overview of the current Venue's details.",
                "details_title": "Details Tab",
                "edit_message": "In this tab, you can modify the details of the Venue. Make sure to save your changes.",
                "edit_title": "Edit Tab",
                "integration_message": "This section allows you to generate an API key and secret. These will be used if you want to integrate your system with just one Venue. If you need to integrate the entire system, please check the POS Integration part.",
                "integration_title": "Integration Tab",
                "statistics_message": "This tab shows transactions grouped by day for the selected period in the top right corner. You will be able to download more detailed transactions as a CSV file, which will be enabled later.",
                "statistics_title": "Statistics Tab",
                "title": "Title"
            },
            "VenueDetails": {
                "address_label": "Address:",
                "city_label": "City:",
                "country_label": "Country:",
                "description_label": "Description:",
                "email_label": "Email:",
                "facebook": "Facebook",
                "instagram": "Instagram",
                "latitude_label": "Latitude:",
                "longitude_label": "Longitude:",
                "name_label": "Name:",
                "organization_label": "Organization:",
                "phone_label": "Phone:",
                "social_media": "Social Media Links",
                "title": "Venue Details",
                "twitter": "Twitter",
                "website_label": "Website:"
            },
            "VenueIntegration": {
                "api_integration": "API Integration",
                "api_key": "API Key",
                "generate_secret": "Generate API Secret",
                "generated_secret": "API Secret: {{secret}}",
                "secret_timer": "Secret will disappear in {{seconds}} seconds."
            },
            "VenueStatistics": {
                "average_price": "Average Price",
                "average_revenue": "Average Revenue",
                "date": "Date",
                "total_discount": "Total Discount",
                "total_price": "Total Price",
                "total_quantity": "Total Quantity",
                "total_revenue": "Total Revenue",
                "total_tax": "Total Tax",
                "total_transactions": "Total Transactions",
                "transaction_count": "Transaction Count"
            },
            "loading": "Loading",
            "tabs": {
                "details": "Details",
                "edit": "Edit Venue",
                "integration": "Integration",
                "statistics": "Statistics"
            },
            "title": "Venue: {{name}}"
        },
        "add_new_button": "Add New",
        "columns": {
            "action": "Action",
            "address": "Address",
            "country": "Country",
            "email": "Email",
            "id": "ID",
            "name": "Name",
            "phone": "Phone"
        },
        "deleteConfirm": "Delete Confirm",
        "deleteError": "Delete Error",
        "deleteSuccess": "Delete Success",
        "deleteTitle": "Delete Title",
        "loadError": "Load Error",
        "noData": "No Data",
        "overview": "Venue Overview",
        "search_placeholder": "Search by name or description",
        "title": "Venues",
        "VenuesProgress": {
            "title": "Title"
        }
    },
    "Warranties": {
        "actions": "Actions",
        "activationDate": "Activation Date",
        "activeWarranties": "Active Warranty",
        "buyer": "Buyer",
        "enterSerialNumber": "Enter serial number to search",
        "errors": {
            "fetchFailed": "Failed to fetch warranty details"
        },
        "expirationDate": "Expiration Date",
        "issuer": "Issuer",
        "item": "Item",
        "loading": "Loading...",
        "noWarranties": "No warranties found",
        "of": "of",
        "question": "Ask a Question",
        "rowsPerPage": "Rows per page",
        "searchWarranties": "Search Warranty",
        "serialNumber": "Serial Number",
        "status": "Status",
        "title": "Warranties",
        "tutorial": "Tutorial",
        "tutorialContent": "View and manage active warranties for items sold by your organization.",
        "tutorialTitle": "Active Warranty Tutorial",
        "viewItem": "View item",
        "warrantiesOverview": "Warranty Overview",
        "warrantyTemplates": "Warranty Templates"
    },
    "WarrantyTemplates": {
        "actions": "Actions",
        "active": "Active",
        "applicability": "Applicability",
        "applicabilityAll": "All",
        "applicabilityCategory": "Category",
        "applicabilityId": "Applicability Selection",
        "applicabilityManufacturer": "Manufacturer",
        "applicabilityManufacturerItem": "Manufacturer Item",
        "applicabilityType": "Applicability Type",
        "back": "Back",
        "cancel": "Cancel",
        "category": "Category",
        "claimProcess": "Claim Process (JSON)",
        "create": "Create Template",
        "createTitle": "Create Warranty Template",
        "delete": "Delete",
        "deleteConfirm": "Are you sure you want to delete template \"{name}\"? This action cannot be undone.",
        "deleteTitle": "Delete Template",
        "description": "Description",
        "detailsTitle": "Details Title",
        "duration": "Duration",
        "durationMonths": "Duration (Months)",
        "edit": "Edit",
        "editTitle": "Edit Warranty Template",
        "errors": {
            "applicabilityIdRequired": "Applicability selection is required",
            "applicabilityTypeRequired": "Applicability type is required",
            "categoryRequired": "Category is required",
            "createFailed": "Failed to create template",
            "deleteFailed": "Failed to delete template",
            "durationInvalid": "Duration must be a positive number",
            "fetchFailed": "Failed to fetch template details",
            "invalidJson": "Invalid JSON format",
            "nameRequired": "Name is required",
            "typeRequired": "Template type is required",
            "updateFailed": "Failed to update template"
        },
        "filterCategory": "Filter by Category",
        "filterType": "Filter by Type",
        "inactive": "Inactive",
        "isActive": "Active",
        "loading": "Loading...",
        "manufacturerItemId": "Manufacturer Item Id",
        "manufacturerItemName": "Manufacturer Item Name",
        "name": "Name",
        "noTemplates": "No warranty templates found",
        "noVersions": "No Versions",
        "of": "of",
        "question": "Ask a Question",
        "rowsPerPage": "Rows per page",
        "searchPlaceholder": "Search by template name",
        "status": "Status",
        "submit": "Submit",
        "terms": "Terms (JSON)",
        "title": "Warranty Templates",
        "tutorial": "Tutorial",
        "tutorialContent": "Manage warranty templates for your reseller organization. Create, edit, or delete templates to apply warranties to sold items.",
        "tutorialTitle": "Warranty Templates Tutorial",
        "type": "Type",
        "updated": "Updated",
        "version": "Version",
        "versions": "Versions"
    },
    "common": {
        "active": "Active",
        "cancel": "Cancel",
        "create": "Create",
        "delete": "Delete",
        "edit": "Edit",
        "inactive": "Inactive",
        "loading": "Loading…",
        "next": "Next",
        "none": "None",
        "previous": "Previous",
        "save": "Save",
        "saving": "Saving",
        "select": "Select…",
        "unknown": "Unknown",
        "update": "Update"
    },
    "forgotPasswordPage": {
        "back_to_login": "Back to Login",
        "code_label": "Six-digit code",
        "code_sent": "We sent a six-digit code if an account exists for that email.",
        "email_label": "Email Address",
        "instructions": "Enter your email address and we will send you a code to reset your password.",
        "loading": "Sending...",
        "password_changed": "Your password has been changed. You can now sign in.",
        "password_confirmation_label": "Confirm new password",
        "password_label": "New password",
        "password_mismatch": "The passwords do not match.",
        "reset_button": "Set new password",
        "reset_instructions": "Enter the six-digit code from the email and choose your new password.",
        "reset_link_error": "Failed to send reset link. Please try again.",
        "reset_link_sent": "Reset link sent to your email!",
        "submit_button": "Send Reset Link",
        "title": "Forgot Password"
    },
    "loading": "Loading",
    "AdminCategoryMapper": {
        "actions": {
            "saveAll": "Save All",
            "saveRow": "Save Row"
        },
        "codeLabel": "Code Label",
        "columns": {
            "gpc": "Gpc"
        },
        "filters": {
            "level": "Level",
            "unmappedOnly": "Unmapped Only"
        },
        "levelLabel": "Level Label",
        "loadError": "Load Error",
        "loading": "Loading",
        "pageTitle": "Page Title",
        "placeholders": {
            "searchGpc": "Search Gpc"
        },
        "searchSourceLabel": "Search Source Label"
    },
    "AdminOrganizations": {
        "actions": {
            "add": "Add",
            "create": "Create"
        },
        "columns": {
            "actions": "Actions",
            "active": "Active",
            "country": "Country",
            "email": "Email",
            "name": "Name",
            "type": "Type"
        },
        "empty": "Empty",
        "errors": {
            "load": "Load"
        },
        "filters": {
            "allTypes": "All Types",
            "searchPlaceholder": "Search Placeholder"
        },
        "form": {
            "organizationType": "Organization Type"
        },
        "loading": "Loading",
        "modal": {
            "addTitle": "Add Title",
            "editTitle": "Edit Title"
        },
        "stats": {
            "total": "Total"
        },
        "title": "Title"
    },
    "AdminPromotionTypes": {
        "actions": {
            "addEntity": "Add Entity",
            "deleteSelected": "Delete Selected",
            "editSelected": "Edit Selected"
        },
        "attributeModal": {
            "addTitle": "Add Title",
            "dataTypePlaceholder": "Data Type Placeholder",
            "editTitle": "Edit Title",
            "functionalityOptional": "Functionality Optional",
            "save": "Save",
            "supportedOperatorsPlaceholder": "Supported Operators Placeholder"
        },
        "attributes": {
            "add": "Add",
            "empty": "Empty",
            "loading": "Loading",
            "selectTypeHint": "Select Type Hint",
            "title": "Title"
        },
        "columns": {
            "attributes": "Attributes",
            "dataType": "Data Type",
            "operators": "Operators",
            "targetModel": "Target Model"
        },
        "deleteModal": {
            "body": "Body",
            "title": "Title"
        },
        "loadError": "Load Error",
        "loading": "Loading",
        "pageTitle": "Page Title",
        "typeModal": {
            "addTitle": "Add Title",
            "editTitle": "Edit Title",
            "targetModelOptional": "Target Model Optional"
        }
    },
    "AdminScannedBills": {
        "detail": {
            "adminNotesOptional": "Admin Notes Optional",
            "ai": {
                "analyzing": "Analyzing",
                "extractedBanner": "Extracted Banner",
                "forceRerun": "Force Rerun",
                "runAnalysis": "Run Analysis"
            },
            "cachedAt": "Cached At",
            "createNewVirtual": "Create New Virtual",
            "createVirtualOrganizationDesc": "This retailer is not in the database. A virtual entry is created, which a real account can claim later.",
            "createVirtualVenueDesc": "This location is not in the database. A virtual entry is created under the retailer.",
            "linkToExisting": "Link To Existing",
            "notSelected": "Not Selected",
            "pageTitle": "Page Title",
            "placeholders": {
                "adminNotes": "Admin Notes",
                "createManufacturer": "Create Manufacturer",
                "createProduct": "Create Product",
                "organizationName": "Organization Name",
                "searchOrCreateManufacturer": "Search Or Create Manufacturer",
                "searchOrganizations": "Search Organizations",
                "searchProducts": "Search Products",
                "searchVenues": "Search Venues",
                "venueName": "Venue Name"
            },
            "possibleMatches": "Possible Matches",
            "processing": {
                "allVirtualDesc": "Neither the retailer nor the manufacturer exists as a real account yet, so nobody has to confirm this. The bill is created immediately and the buyer gets the warranty.",
                "allVirtualTitle": "Goes through without anyone's approval",
                "manufacturerVerificationSuffix": "Manufacturer Verification Suffix",
                "needsManufacturerApproval": "Needs Manufacturer Approval",
                "processBill": "Process Bill",
                "processing": "Processing",
                "productsCount": "Products Count",
                "realNeedsApproval": "Real Needs Approval",
                "retailerQueueDesc": "The retailer is a real account, so the bill is sent to them to confirm before the warranty starts.",
                "retailerQueueTitle": "Waits for the retailer",
                "whatWillHappen": "What Will Happen",
                "willCreateVirtual": "Will Create Virtual"
            },
            "retailerSearchDesc": "Search for an existing retailer, or create one from what the receipt says.",
            "sections": {
                "aiAnalysis": "Ai Analysis",
                "items": "Items",
                "processingSummary": "Processing Summary",
                "retailerOrganization": "Retailer Organization",
                "venue": "Venue"
            },
            "unknownItem": "Unknown Item",
            "venueSearchDesc": "Search for an existing location, or create one from the address on the receipt."
        }
    },
    "AdminCities": {
        "title": "Cities",
        "loading": "Loading cities...",
        "empty": "No cities found.",
        "errors": {
            "load": "Failed to load cities."
        },
        "stats": {
            "total": "Total Cities",
            "capitals": "Capital Cities",
            "countries": "Countries"
        },
        "filters": {
            "searchPlaceholder": "Search by city or country...",
            "allCountries": "All countries",
            "allCities": "All cities",
            "capitalsOnly": "Capitals only",
            "nonCapitals": "Non-capitals"
        },
        "columns": {
            "name": "Name",
            "country": "Country",
            "coordinates": "Coordinates",
            "population": "Population",
            "capital": "Capital",
            "actions": "Actions"
        },
        "actions": {
            "add": "Add City",
            "create": "Create City"
        },
        "modal": {
            "addTitle": "Add City",
            "editTitle": "Edit City",
            "deleteTitle": "Delete City",
            "deleteConfirm": "Are you sure you want to delete {{name}}?"
        },
        "form": {
            "name": "City name",
            "selectCountry": "Select country",
            "latitude": "Latitude",
            "longitude": "Longitude",
            "region": "Region",
            "population": "Population",
            "isCapital": "Capital city",
            "coordinatesHint": "Use decimal coordinates (e.g. 43.8563, 18.4131)."
        }
    },
    "AdminUsers": {
        "actions": {
            "addUser": "Add User",
            "approveTermination": "Approve termination",
            "createUser": "Create User",
            "refreshList": "Refresh List",
            "updateUser": "Update User"
        },
        "columns": {
            "actions": "Actions",
            "city": "City",
            "created": "Created",
            "defaultPassword": "Default Password",
            "email": "Email",
            "name": "Name",
            "phone": "Phone",
            "roles": "Roles",
            "terminationStatus": "Termination"
        },
        "deleteModal": {
            "confirmPrefix": "Confirm Prefix",
            "description": "Description",
            "title": "Title"
        },
        "empty": "Empty",
        "errors": {
            "load": "Load"
        },
        "filters": {
            "allCountries": "All Countries",
            "allOrganizations": "All Organizations",
            "allRoles": "All Roles",
            "anyPasswordState": "Any Password State",
            "changedPassword": "Changed Password",
            "defaultPassword": "Default Password",
            "searchPlaceholder": "Search Placeholder"
        },
        "listTitle": "List Title",
        "loading": "Loading",
        "modal": {
            "additionalDetails": "Additional Details",
            "createTitle": "Create Title",
            "editTitle": "Edit Title",
            "phoneCountry": "Phone Country",
            "roles": "Roles",
            "selectOrganization": "Select Organization"
        },
        "stats": {
            "createNew": "Create New",
            "editingUser": "Editing User",
            "mode": "Mode",
            "totalUsers": "Total Users"
        },
        "termination": {
            "active": "Active",
            "pending": "Pending request",
            "modalTitle": "Approve account termination",
            "confirmPrefix": "Approve termination and delete user",
            "confirmDescription": "This action deletes the user now. Bill archive email is currently a backend placeholder and will be implemented later."
        },
        "tabs": {
            "statistics": "Statistics",
            "users": "Users"
        },
        "title": "Title"
    },
    "CustomIntegratorPanel": {
        "actions": {
            "rotateCredentials": "Rotate Credentials"
        },
        "confirm": {
            "deleteWebhook": "Delete Webhook",
            "rotateCredentials": "Rotate Credentials"
        },
        "credentials": {
            "apiKey": "Api Key",
            "apiSecret": "Api Secret",
            "notGenerated": "Not Generated",
            "subtitle": "Subtitle",
            "title": "Title"
        },
        "docs": {
            "quickStart": "Quick Start",
            "viewFull": "View Full"
        },
        "errors": {
            "deleteWebhook": "Delete Webhook",
            "loadCredentials": "Load Credentials",
            "rotateCredentials": "Rotate Credentials",
            "saveWebhook": "Save Webhook",
            "testWebhook": "Test Webhook",
            "webhookTestFailedWithReason": "Webhook Test Failed With Reason"
        },
        "health": {
            "customersCreated": "Customers Created",
            "errors24h": "Errors24h",
            "logTypes": {
                "all": "All",
                "error": "Error",
                "request": "Request",
                "webhook": "Webhook"
            },
            "noActivity": "No Activity",
            "productsSynced": "Products Synced",
            "recentActivity": "Recent Activity",
            "subtitle": "Subtitle",
            "title": "Title",
            "transactionsProcessed": "Transactions Processed"
        },
        "security": {
            "body": "Body",
            "title": "Title"
        },
        "tabs": {
            "credentials": "Credentials",
            "healthMonitoring": "Health Monitoring",
            "webhooks": "Webhooks"
        },
        "toasts": {
            "copiedToClipboard": "Copied To Clipboard",
            "credentialsRotated": "Credentials Rotated",
            "updateIntegrationNow": "Update Integration Now",
            "webhookCreated": "Webhook Created",
            "webhookDeleted": "Webhook Deleted",
            "webhookTestSuccess": "Webhook Test Success",
            "webhookUpdated": "Webhook Updated"
        },
        "webhooks": {
            "actions": {
                "delete": "Delete",
                "edit": "Edit",
                "test": "Test"
            },
            "addWebhook": "Add Webhook",
            "emptySubtitle": "Empty Subtitle",
            "emptyTitle": "Empty Title",
            "meta": {
                "allEvents": "All Events",
                "events": "Events",
                "lastDelivery": "Last Delivery",
                "never": "Never",
                "successRate": "Success Rate"
            },
            "modal": {
                "createTitle": "Create Title",
                "editTitle": "Edit Title",
                "eventsToSubscribe": "Events To Subscribe",
                "saveWebhook": "Save Webhook",
                "webhookUrl": "Webhook Url",
                "webhookUrlPlaceholder": "Webhook Url Placeholder"
            },
            "title": "Title"
        }
    }
};
